import React, { useState, useEffect, useCallback } from "react";
import "./tokens.css";
// CSS-Reihenfolge ist hier festgelegt, nicht durch die Import-Reihenfolge der
// Komponenten: erst die Grundbausteine, dann die gemeinsamen Regeln
// (App.css), dann der Rest in der Reihenfolge, in der die Regeln frueher in
// App.css standen. Gleich spezifische Regeln ueberschreiben sich sonst je
// nach Ladereihenfolge anders.
import "./components/Button.css";
import "./App.css";
import "./screens/LoginScreen.css";
import "./components/dialoge/PunkteDialog.css";
import "./components/Vinyl.css";
import "./screens/SetupScreen.css";
import "./screens/host/WiederholungDialog.css";
import "./components/Countdown.css";
import "./components/TaskHeading.css";
import "./components/dialoge/GeraeteDialog.css";
import "./components/HistoryList.css";
import "./components/dialoge/EinstellungenDialog.css";
import "./components/Podium.css";
import "./screens/JoinScreen.css";
import "./screens/LobbyScreen.css";
import "./components/BuzzerArea.css";
import "./screens/PlayerGameScreen.css";
import "./components/dialoge/ProtokollDialog.css";
import "./components/dialoge/RaumDialog.css";
import "./components/JahrUebersicht.css";
// Ehemalige Inline-Styles: zuletzt, sie sollen wie vorher gewinnen
import "./components/SongLoesung.css";
import "./screens/FinishedScreen.css";
import "./screens/host/LoesungHaltenOverlay.css";
// Neuentwurf Spielrunde (Etappe 1): eigene Klassennamen, kollidiert nicht
// mit den alten Regeln oben.
import "./components/Avatar.css";
import "./components/PunktePille.css";
import "./components/SpielKopf.css";
import "./components/Spiel.css";
import "./components/Stopp.css";
import "./components/Sheet.css";
import "./components/SpielerKacheln.css";
import "./components/Ziffernblock.css";
import "./components/Rangliste.css";
import "./components/DuBistDran.css";
import "./screens/host/HostSpiel.css";
// Neuentwurf Einstieg (Etappe 2)
import "./components/Notiz.css";
import "./components/WegKarte.css";
import "./components/CodeFelder.css";
import "./components/TextFeld.css";
import "./components/QrKarte.css";
import "./components/PersonenListe.css";
import "./components/StatusChip.css";
import "./components/Auswahl.css";
import "./components/Einstieg.css";
import "./components/Leiste.css";
import {
  remainingFromDeadline,
  resolveStartDurationMs,
  decideSongTracking,
} from "./quizLogic";
import { useRoom } from "./useRoom";
import { loadRoomSession } from "./roomClient";
import { logEvent } from "./diagnostics";
import { ladeSpotifySdk, SDK_FEHLERTEXTE, PLAYER_NAME, istQuizPlayer, verbergeSongInfo } from "./spotifyPlayer";
import Button from "./components/Button";
import BuzzerArea from "./components/BuzzerArea";
import DuBistDran from "./components/DuBistDran";
import HistoryModal from "./components/HistoryModal";
import { Umbuchen } from "./components/HistoryList";
import Leiste from "./components/Leiste";
import EinstellungenDialog from "./components/dialoge/EinstellungenDialog";
import GeraeteDialog from "./components/dialoge/GeraeteDialog";
import ProtokollDialog from "./components/dialoge/ProtokollDialog";
import PunkteDialog from "./components/dialoge/PunkteDialog";
import RaumDialog from "./components/dialoge/RaumDialog";
import JoinScreen from "./screens/JoinScreen";
import LobbyScreen from "./screens/LobbyScreen";
import PlayerGameScreen from "./screens/PlayerGameScreen";
import LoginScreen from "./screens/LoginScreen";
import SetupScreen from "./screens/SetupScreen";
import FinishedScreen from "./screens/FinishedScreen";
import GeraeteBanner from "./screens/host/GeraeteBanner";
import HostSpiel from "./screens/host/HostSpiel";
import LoesungHaltenOverlay from "./screens/host/LoesungHaltenOverlay";
import ReauthBanner from "./screens/host/ReauthBanner";
import WiederholungDialog from "./screens/host/WiederholungDialog";
import { farbNummern } from "./spieler";

// Zuletzt genutztes Wiedergabe-Gerät. Überlebt Reloads, damit nach einem
// Verbindungsabriss automatisch dasselbe Gerät reaktiviert wird.
const LAST_DEVICE_KEY = "musicQuizLastDevice";
// Der NAME zusätzlich zur ID: Spotify vergibt beim Neustart der App eine neue
// device_id, der Name bleibt. Ohne ihn findet die App dasselbe Gerät nicht wieder.
const LAST_DEVICE_NAME_KEY = "musicQuizLastDeviceName";
// Vom Nutzer BEWUSST im Gerätedialog gewähltes Gerät. Unterscheidet sich von
// LAST_DEVICE_KEY, das auch automatisch gesetzt wird: nur eine echte Auswahl
// darf verhindern, dass die App die Wiedergabe wieder zu sich holt.
const GEWAEHLT_KEY = "musicQuizGewaehltesGeraet";
const HOST_NAME_KEY = "musicQuizHostName";
const GEWAEHLT_TYP_KEY = "musicQuizGewaehltesGeraetTyp";

// Spotify-Refresh-Tokens laufen von sich aus NIE ab. Ohne Befristung bliebe
// eine einmal erteilte Anmeldung unbegrenzt im Browser liegen. Nach dieser
// Zeit verlangt die App eine frische Anmeldung.
const AUTH_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

// Gescannter Raumcode, der noch nicht zu einem Beitritt geführt hat.
// sessionStorage: gilt nur für diesen Tab und ist beim nächsten Öffnen weg.
const PENDING_JOIN_KEY = "musicQuizPendingJoin";


// Untergrenze fuer einen automatisch uebernommenen Jahres-Tipp. Darunter ist
// es keine Jahreszahl, sondern eine halb fertige Eingabe.
const JAHR_MINDESTWERT = 1500;


function App() {
  // --- STATES ---
  const [gameState, setGameState] = useState("LOGIN");
  const [roundStage, setRoundStage] = useState("TASK"); // TASK, READY, PLAYING, SOLVED, JUDGE
  const [taskType, setTaskType] = useState("TITLE"); // TITLE, ARTIST, YEAR
  const [token, setToken] = useState(null);
  const [players, setPlayers] = useState([
    { name: "", score: 0 },
    { name: "", score: 0 },
  ]);
  const [timer, setTimer] = useState(20);
  // Volle Dauer des laufenden Songs in Sekunden (fuer den Countdown-Ring).
  // "Weiterhoeren" behaelt sie, damit der Ring dort weiterlaeuft, wo er stand.
  const [timerGesamt, setTimerGesamt] = useState(null);
  const [showExitConfirm, setShowExitConfirm] = useState(false);
  const [showSolution, setShowSolution] = useState(false);
  const [songData, setSongData] = useState({ title: "", artist: "", year: "" });
  // Runde, in der der Host "Keiner" gewaehlt hat (Bewertung)
  const [keinerRunde, setKeinerRunde] = useState(null);
  const [votedPlayers, setVotedPlayers] = useState([]); // Speichert Indizes der Spieler, die schon einen Punkt haben
  const [activeTasks, setActiveTasks] = useState({
    TITLE: true,
    ARTIST: true,
    YEAR: true,
    ALBUM: false,
  });
  const [showSettings, setShowSettings] = useState(false);
  const [currentPlaylistUri, setCurrentPlaylistUri] = useState(null);
  const [playedSongs, setPlayedSongs] = useState([]);
  const [showRepeatWarning, setShowRepeatWarning] = useState(false);
  const [playlistWarningMuted, setPlaylistWarningMuted] = useState(false);
  const [timeLimit, setTimeLimit] = useState(0); // 0 bedeutet unlimited
  const timerRef = React.useRef(null);
  // Zielzeitpunkt des laufenden Countdowns (null = kein Zeitlimit)
  const timerDeadlineRef = React.useRef(null);
  // Beim Stoppen gesicherte Restzeit in ms (0 = Limit war bereits abgelaufen)
  const timerRemainingMsRef = React.useRef(0);
  // Runde kam durch ein Neuladen zum Stehen, nicht durch Zeitablauf. Dann
  // darf die Jahres-Auswertung nicht von selbst starten.
  const jahrAutoStoppRef = React.useRef(false);
  // Fix für den Replay-Bug: Wir merken uns die aktuelle ID
  const [currentSongId, setCurrentSongId] = useState(null);
  // Für das Mobile Scoreboard Overlay
  const [showMobileScores, setShowMobileScores] = useState(false);
  // Startwert war "DISCONNECTED" -> direkt nach dem Login leuchtete rot
  // "Verbindung unterbrochen", obwohl noch gar nichts geprüft war.
  const [spotifyStatus, setSpotifyStatus] = useState("CHECKING");
  const [activeDeviceId, setActiveDeviceId] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [tokenExpiry, setTokenExpiry] = useState(null);
  // Zeitpunkt der letzten echten Anmeldung — Basis für die 30-Tage-Frist
  const [authGrantedAt, setAuthGrantedAt] = useState(null);
  const authGrantedAtRef = React.useRef(null);
  const [isSongLoading, setIsSongLoading] = useState(false);
  const [matchHistory, setMatchHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [roundCount, setRoundCount] = useState(1);
  // true, sobald das Refresh-Token endgültig abgelehnt wurde. Nur dann ist eine
  // echte Neuanmeldung nötig — reine Netzwerkaussetzer setzen das NICHT.
  const [needsReauth, setNeedsReauth] = useState(false);
  const [authError, setAuthError] = useState(null);
  const statusFailuresRef = React.useRef(0);
  // Zeitpunkt, an dem die Seite in den Hintergrund ging — fürs Protokoll
  const wegSeitRef = React.useRef(null);
  // Seit wann die Musik pausiert ist. Misst, wie lange ein Spotify-Gerät eine
  // Pause übersteht, bevor es sich abmeldet.
  const pausiertSeitRef = React.useRef(null);
  const activeDeviceIdRef = React.useRef(null);
  // Geräte-Auswahl: schlafendes Spotify-Gerät wieder aktivieren, ohne Neuanmeldung
  const [devices, setDevices] = useState([]);
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [showDiagModal, setShowDiagModal] = useState(false);
  // Raumcode gross: zum Rumzeigen am Tisch
  const [showRoomModal, setShowRoomModal] = useState(false);
  const [devicesLoading, setDevicesLoading] = useState(false);
  const [deviceError, setDeviceError] = useState(null);
  // Gemerktes Gerät steht nicht mehr in der Geräteliste — typisch fürs
  // Handy: Spotify meldet sich beim Pausieren im Hintergrund ab.
  const [geraetVerschwunden, setGeraetVerschwunden] = useState(false);

  // --- WIEDERGABE IM BROWSER (Web Playback SDK) ---
  // Die Quiz-Seite selbst als Spotify-Gerät. Damit gibt es keine Spotify-App
  // im Hintergrund mehr, die iOS beim Pausieren einfrieren könnte.
  const playerRef = React.useRef(null);
  const sdkGeraetIdRef = React.useRef(null);
  // Zuletzt vergebene Geraete-ID des eigenen Players. Ueberlebt "not_ready" —
  // nur so laesst sich nach einer Neuverbindung erkennen, dass die gemerkten
  // Geraete-IDs auf eine tote ID zeigen.
  const letzteSdkIdRef = React.useRef(null);
  const sdkGestartetRef = React.useRef(false);
  // Wurde schon versucht, die Wiedergabe hierher zu holen?
  const uebernahmeVersuchtRef = React.useRef(false);
  const [sdkGeraetId, setSdkGeraetId] = useState(null);
  // Wann der Player zuletzt "bereit" meldete (Karenzzeit gegen Fehlalarme)
  const sdkBereitSeitRef = React.useRef(0);
  const [sdkFehler, setSdkFehler] = useState(null);
  const [sdkBrauchtNeuanmeldung, setSdkBrauchtNeuanmeldung] = useState(false);
  // Zaehlt jedes "bereit" des Players — auch wenn die Geraete-ID gleich bleibt
  const [sdkBereitZaehler, setSdkBereitZaehler] = useState(0);

  // --- BUZZER-MODUS ---
  // screen liegt QUER zu gameState: Beitritt und Lobby sind eigene Ansichten,
  // die auch ohne Spotify-Login erreichbar sein müssen.
  const [screen, setScreen] = useState(null); // null | "JOIN" | "LOBBY"
  const [joinCode, setJoinCode] = useState("");
  const [joinName, setJoinName] = useState("");
  const [joinInfo, setJoinInfo] = useState(null);
  const [joinBusy, setJoinBusy] = useState(false);
  const [gameMode, setGameMode] = useState("BUZZER"); // BUZZER | CLASSIC — Buzzer ist der Normalfall
  // Name des Hosts als Spieler (Buzzer-Modus). Gemerkt, damit er ihn nicht
  // jeden Abend neu tippt.
  const [hostPlayerName, setHostPlayerName] = useState(() => {
    try {
      return localStorage.getItem(HOST_NAME_KEY) || "";
    } catch (e) {
      return "";
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(HOST_NAME_KEY, hostPlayerName);
    } catch (e) { /* egal */ }
  }, [hostPlayerName]);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  // Jahres-Runde: was gerade im Eingabefeld steht
  const [jahrTipp, setJahrTipp] = useState("");
  // Name dessen, der sich in dieser Runde selbst als richtig gemeldet hat
  const [selbstGemeldet, setSelbstGemeldet] = useState(null);
  // Der Host hat den Punkt dieser Runde bewusst wieder abgewaehlt. Ohne den
  // Merker wuerde der Name aus dem Raum (Selbstmeldung) sofort zurueckkommen.
  const [punktEntfernt, setPunktEntfernt] = useState(false);
  const room = useRoom();

  // Wem gehoert ein Verlaufseintrag JETZT?
  //
  // Der Platz in der Liste taugt dafuer nicht: im Buzzer-Modus fuehrt der
  // Raum die Spielerliste, und ein Rauswurf mitten im Spiel schiebt alle
  // dahinter eine Position nach vorn. Ein alter Eintrag zeigte danach auf
  // den Falschen — und eine Korrektur haette dem Falschen den Punkt
  // abgezogen. Die roomId bleibt dagegen an der Person.
  const spielerIndexVon = (entry, liste = players) => {
    if (!entry) return null;
    if (entry.roomId) {
      // Person nicht mehr da (rausgeworfen): dann gehoert der Eintrag
      // niemandem. Der alte Listenplatz zeigt inzwischen auf den Nachbarn —
      // der haette beim Loeschen oder Umbuchen den Punkt verloren.
      const idx = liste.findIndex((p) => p.roomId === entry.roomId);
      return idx === -1 ? null : idx;
    }
    if (entry.playerIndex === null || entry.playerIndex === undefined) return null;
    return entry.playerIndex < liste.length ? entry.playerIndex : null;
  };

  // playerIndex === null: Runde ohne Punkt (keiner wusste es). Solche
  // Eintraege stehen genauso im Verlauf — sonst fehlen hinterher genau die
  // Songs, ueber die alle reden.
  const handleDeleteHistoryEntry = (entryId) => {
    const entry = matchHistory.find(e => e.id === entryId);
    if (!entry) return;
    const betroffen = spielerIndexVon(entry);
    if (betroffen !== null) {
      setPlayers(prevPlayers => prevPlayers.map((p, idx) => {
        if (idx === betroffen) {
          return { ...p, score: Math.max(0, p.score - 1) };
        }
        return p;
      }));
    }
    setMatchHistory(prev => prev.filter(e => e.id !== entryId));
  };

  // newPlayerIndex === null bucht den Punkt auf "niemand" zurueck.
  const handleReassignHistoryEntry = (entryId, newPlayerIndex) => {
    const entry = matchHistory.find(e => e.id === entryId);
    if (!entry) return;
    // Der alte Empfaenger kommt ueber die roomId, nicht ueber den gemerkten
    // Platz — sonst verliert nach einem Rauswurf der Nachbar den Punkt.
    const alt = spielerIndexVon(entry);
    const neu = newPlayerIndex === undefined ? null : newPlayerIndex;
    if (alt === neu) return;

    setPlayers(prevPlayers => prevPlayers.map((p, idx) => {
      let score = p.score;
      if (alt !== null && idx === alt) score = Math.max(0, score - 1);
      if (neu !== null && idx === neu) score = score + 1;
      return score === p.score ? p : { ...p, score };
    }));
    setMatchHistory(prev => prev.map(e => {
      if (e.id !== entryId) return e;
      return {
        ...e,
        playerIndex: neu,
        roomId: neu === null ? null : players[neu]?.roomId || null,
        playerName:
          neu === null
            ? null
            : players[neu]?.name || `Spieler ${neu + 1}`,
      };
    }));
  };

  // Neue Funktion zum Hinzufügen eines Spielers
  const addPlayer = () => {
    setPlayers([...players, { name: "", score: 0 }]);
  };

  // --- TOKEN HANDLING ---
  // Refs statt State in den Fetch-Helfern: so bleibt `spotifyFetch` referenz-stabil.
  // Sonst wurde bei jedem Token-Wechsel jedes Keep-Alive-Interval neu aufgebaut.
  const tokenRef = React.useRef(null);
  const refreshTokenRef = React.useRef(null);
  const refreshPromiseRef = React.useRef(null);

  useEffect(() => {
    activeDeviceIdRef.current = activeDeviceId;
    if (activeDeviceId) localStorage.setItem(LAST_DEVICE_KEY, activeDeviceId);
  }, [activeDeviceId]);

  const tokenExpiryRef = React.useRef(null);
  useEffect(() => { tokenExpiryRef.current = tokenExpiry; }, [tokenExpiry]);

  useEffect(() => { tokenRef.current = token; }, [token]);
  useEffect(() => { refreshTokenRef.current = refreshToken; }, [refreshToken]);
  useEffect(() => { authGrantedAtRef.current = authGrantedAt; }, [authGrantedAt]);

  // isFreshLogin: nur bei einer echten Neuanmeldung beginnt die 30-Tage-Frist
  // neu. Ein Token-Refresh darf sie NICHT verlängern, sonst liefe sie nie ab.
  const applyTokens = useCallback((accessToken, newRefreshToken, expiresIn, isFreshLogin = false) => {
    tokenRef.current = accessToken;
    setToken(accessToken);
    if (newRefreshToken) {
      refreshTokenRef.current = newRefreshToken;
      setRefreshToken(newRefreshToken);
    }
    setTokenExpiry(Date.now() + Number(expiresIn || 3600) * 1000);
    if (isFreshLogin) {
      authGrantedAtRef.current = Date.now();
      setAuthGrantedAt(Date.now());
    }
    setNeedsReauth(false);
  }, []);

  /** Verwirft die Spotify-Anmeldung, behält aber Punkte und Verlauf. */
  const clearSpotifyAuth = useCallback((grund) => {
    tokenRef.current = null;
    refreshTokenRef.current = null;
    setToken(null);
    setRefreshToken(null);
    setTokenExpiry(null);
    setAuthGrantedAt(null);
    authGrantedAtRef.current = null;
    setNeedsReauth(true);
    if (grund) setAuthError(grund);
  }, []);

  const refreshSpotifyToken = useCallback(async () => {
    const currentRefreshToken = refreshTokenRef.current;
    if (!currentRefreshToken) {
      setNeedsReauth(true);
      return null;
    }

    // Anmeldung älter als die Frist? Dann nicht erneuern, sondern verwerfen.
    const grantedAt = authGrantedAtRef.current;
    if (grantedAt && Date.now() - grantedAt > AUTH_MAX_AGE_MS) {
      console.warn("Anmeldung älter als 30 Tage — bitte neu verbinden.");
      clearSpotifyAuth(null);
      return null;
    }

    // Single-Flight: mehrere gleichzeitige 401er teilen sich EINEN Refresh-Request.
    // Vorher konnten parallele Refreshes das rotierende Refresh-Token gegenseitig entwerten.
    if (refreshPromiseRef.current) return refreshPromiseRef.current;

    const run = (async () => {
      try {
        const response = await fetch("/api/spotify/refresh", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refresh_token: currentRefreshToken }),
        });

        if (!response.ok) {
          logEvent("token", "Refresh abgelehnt", { code: response.status });
          // 400/401 = Refresh-Token endgültig ungültig -> echte Neuanmeldung nötig.
          // Alles andere (502, 5xx) ist ein temporäres Problem, kein Grund zum Ausloggen.
          if (response.status === 400 || response.status === 401) {
            console.warn("Refresh-Token abgelehnt — Neuanmeldung nötig.");
            setNeedsReauth(true);
          }
          return null;
        }

        const data = await response.json();
        if (!data.access_token) {
          setNeedsReauth(true);
          return null;
        }
        applyTokens(data.access_token, data.refresh_token, data.expires_in);
        logEvent("token", "erneuert", { gueltigSek: Number(data.expires_in) || null });
        return data.access_token;
      } catch (err) {
        // Netzwerkfehler (Funkloch, Tab war offline): Token bleibt gültig, später neu versuchen.
        logEvent("token", "Refresh nicht erreichbar", { fehler: err.message });
        console.warn("Token-Refresh nicht erreichbar:", err.message);
        return null;
      } finally {
        refreshPromiseRef.current = null;
      }
    })();

    refreshPromiseRef.current = run;
    return run;
  }, [applyTokens, clearSpotifyAuth]);

  const spotifyFetch = useCallback(async (url, options = {}) => {
    const doFetch = (accessToken) =>
      fetch(url, {
        ...options,
        headers: { ...options.headers, Authorization: `Bearer ${accessToken}` },
      });

    let res = await doFetch(tokenRef.current);

    if (res.status === 401) {
      const newToken = await refreshSpotifyToken();
      if (newToken) res = await doFetch(newToken);
    }
    return res;
  }, [refreshSpotifyToken]);

  // --- GERÄTE ---
  /** Merkt sich ID *und* Name — die ID allein überlebt einen Spotify-Neustart nicht. */
  const merkeGeraet = useCallback((geraet) => {
    if (!geraet || !geraet.id) return;
    activeDeviceIdRef.current = geraet.id;
    setActiveDeviceId(geraet.id);
    try {
      localStorage.setItem(LAST_DEVICE_KEY, geraet.id);
      if (geraet.name) localStorage.setItem(LAST_DEVICE_NAME_KEY, geraet.name);
    } catch (e) { /* Speicher voll — nicht kritisch */ }
  }, []);

  const loadDevices = useCallback(async () => {
    setDevicesLoading(true);
    setDeviceError(null);
    try {
      const res = await spotifyFetch("/api/spotify/devices");
      if (!res.ok) {
        setDeviceError("Geräte konnten nicht geladen werden.");
        setDevices([]);
        return [];
      }
      const data = await res.json();
      const list = data.devices || [];
      setDevices(list);
      const active = list.find((d) => d.is_active);
      if (active) {
        merkeGeraet(active);
      }
      return list;
    } catch (err) {
      setDeviceError("Keine Verbindung zu Spotify.");
      setDevices([]);
      return [];
    } finally {
      setDevicesLoading(false);
    }
  }, [spotifyFetch, merkeGeraet]);

  const openDevicePicker = useCallback(() => {
    setShowDeviceModal(true);
    loadDevices();
  }, [loadDevices]);

  // Übernimmt die Wiedergabe auf das gewählte Gerät. play:false = nur aktivieren,
  // ohne sofort loszuspielen (sonst verrät der Song die Antwort).
  const activateDevice = useCallback(
    async (geraet, grund = "manuell") => {
      // Nimmt das ganze Gerät entgegen, nicht nur die ID: nur so lässt sich
      // der Name merken, über den es nach einem Spotify-Neustart wiederfindbar ist.
      const deviceId = typeof geraet === "string" ? geraet : geraet?.id;
      if (!deviceId) return false;
      setDeviceError(null);
      try {
        const res = await spotifyFetch("/api/spotify/player", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ device_ids: [deviceId], play: false }),
        });
        if (!res.ok && res.status !== 202 && res.status !== 204) {
          logEvent("geraet", "Auswahl fehlgeschlagen", { code: res.status });
          // 404 heißt: das Gerät stand zwar noch in der Liste, ist aber
          // zwischen Anzeige und Klick abgetaucht. "In Spotify Play drücken"
          // ging da ins Leere — es läuft ja nichts mehr, was man drücken könnte.
          if (res.status === 404) {
            setGeraetVerschwunden(true);
            setDeviceError("Dieses Gerät ist gerade offline. Spotify dort öffnen, dann erscheint es wieder.");
          } else {
            setDeviceError("Gerät konnte nicht aktiviert werden. In Spotify kurz Play drücken und erneut versuchen.");
          }
          return false;
        }
        merkeGeraet(typeof geraet === "string" ? { id: deviceId } : geraet);
        logEvent("geraet", grund === "auto" ? "automatisch gewaehlt" : "manuell gewaehlt", {
          name: geraet?.name || deviceId,
        });
        // Eine bewusste Wahl gilt: der automatische Griff zur Quiz-Seite darf
        // sie nicht beim nächsten Laden wieder überstimmen.
        if (grund === "manuell") {
          try {
            localStorage.setItem(GEWAEHLT_KEY, deviceId);
            localStorage.setItem(GEWAEHLT_TYP_KEY, (typeof geraet === "object" && geraet?.type) || "");
          } catch (e) { /* egal */ }
        }
        statusFailuresRef.current = 0;
        // Spotify braucht einen Moment, bis der Transfer greift
        setTimeout(() => loadDevices(), 800);
        setShowDeviceModal(false);
        return true;
      } catch (err) {
        setDeviceError("Keine Verbindung zu Spotify.");
        return false;
      }
    },
    [spotifyFetch, loadDevices, merkeGeraet]
  );

  // Stilles Wiederherstellen der Geräteverbindung.
  // Mobile Browser frieren Timer ein, sobald der Bildschirm aus ist oder man die
  // App wechselt — Spotify markiert das Gerät dann als inaktiv. Statt den User
  // damit zu behelligen, holen wir uns das zuletzt genutzte Gerät selbst zurück.
  const ensureActiveDevice = useCallback(async () => {
    try {
      const res = await spotifyFetch("/api/spotify/devices");
      if (!res.ok) return null;
      const data = await res.json();
      const list = data.devices || [];
      if (list.length === 0) return null;
      setDevices(list);

      const preferredId = activeDeviceIdRef.current || localStorage.getItem(LAST_DEVICE_KEY);
      // Spotify vergibt beim Neustart der App eine NEUE device_id für dasselbe
      // Gerät. Die gemerkte ID zeigt dann ins Leere, obwohl der Laptop direkt
      // daneben in der Liste steht — genau daran scheiterte die Erholung:
      // drei Geräte gefunden, keins "passend", Aufgeben. Der Name überlebt.
      const preferredName = localStorage.getItem(LAST_DEVICE_NAME_KEY);
      // Nach einer Neuverbindung haengt der ALTE Quiz-Player bei Spotify noch
      // minutenlang in der Liste. Ueber den Namen haette die Erholung genau
      // diese Leiche erwischt: der Transfer meldet Erfolg, es passiert nichts.
      //
      // ABER: nur filtern, solange wir die lebende ID kennen. Meldet sich der
      // Player gerade als "not_ready", ist sie null — dann haette der Filter
      // das eigene Geraet KOMPLETT geschluckt und die Erholung gab auf,
      // obwohl der Player einwandfrei in der Liste stand.
      const eigeneId = sdkGeraetIdRef.current;
      const eigenesLebt = eigeneId ? list.find((d) => d.id === eigeneId) : null;
      const brauchbar = eigeneId
        ? list.filter((d) => !istQuizPlayer(d.name) || d.id === eigeneId)
        : list;
      const target =
        brauchbar.find((d) => d.is_active) ||
        brauchbar.find((d) => d.id === preferredId) ||
        (preferredName && brauchbar.find((d) => d.name === preferredName)) ||
        // Bevor wir aufgeben: die eigene Seite kann immer spielen.
        eigenesLebt ||
        (brauchbar.length === 1 ? brauchbar[0] : null);

      if (!target) {
        // Das gemerkte Gerät ist nicht bloß inaktiv, es steht ÜBERHAUPT NICHT
        // mehr in der Liste. Per API ist da nichts zu retten: ein Transfer auf
        // eine unbekannte device_id läuft ins Leere. Nur der Mensch kann es
        // zurückholen, indem er Spotify auf dem Gerät wieder öffnet.
        logEvent("geraet", "keins passend", {
          gefunden: list.length,
          gesucht: preferredName || preferredId || "nichts gemerkt",
          namen: list.map((d) => d.name).join(", "),
        });
        setGeraetVerschwunden(true);
        return null;
      }
      setGeraetVerschwunden(false);

      if (!target.is_active) {
        logEvent("geraet", "wird reaktiviert", { name: target.name, typ: target.type });
        const transfer = await spotifyFetch("/api/spotify/player", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ device_ids: [target.id], play: false }),
        });
        if (!transfer.ok && transfer.status !== 202 && transfer.status !== 204) {
          logEvent("geraet", "Reaktivierung fehlgeschlagen", { code: transfer.status });
          return null;
        }
        logEvent("geraet", "wieder aktiv", { name: target.name });
      }

      merkeGeraet(target);
      statusFailuresRef.current = 0;
      return target.id;
    } catch (err) {
      return null;
    }
  }, [spotifyFetch, merkeGeraet]);

  // Verbindung des eigenen Players zu Spotify wiederherstellen.
  //
  // Nach Stunden im Hintergrund ist sie tot: das Gerät steht dann nicht mehr
  // in Spotifys Liste, ist also auch nicht mehr auswählbar — und die
  // Wiedergabe fällt auf die Spotify-App zurück, mitsamt dem alten Problem.
  // Genau das ist am 13.08. abends passiert.
  const letzterReconnectRef = React.useRef(0);
  const reconnectPlayer = useCallback(async () => {
    const p = playerRef.current;
    if (!p) return false;
    if (Date.now() - letzterReconnectRef.current < 10000) return false;
    letzterReconnectRef.current = Date.now();
    try {
      // Erst trennen: connect() auf einem Player, der sich noch fuer
      // verbunden haelt, tut gar nichts — im Protokoll stand dann "neu
      // verbunden", aber nie wieder "bereit", und das Geraet blieb weg
      // (2026-10-05, 14:15–14:22, sechsmal hintereinander).
      try {
        p.disconnect();
      } catch (e) { /* war schon getrennt */ }
      await new Promise((r) => setTimeout(r, 300));
      const ok = await p.connect();
      logEvent("player", ok ? "neu verbunden" : "Neuverbindung abgelehnt");
      // Nach einer Neuverbindung darf die Wiedergabe wieder hierher geholt
      // werden — sonst bliebe sie auf dem Handy hängen.
      if (ok) uebernahmeVersuchtRef.current = false;
      return ok;
    } catch (err) {
      logEvent("player", "Neuverbindung fehlgeschlagen", { fehler: err.message });
      return false;
    }
  }, []);

  // Wiedergabe auf die Quiz-Seite selbst holen ("Dieses Geraet"). Ist der
  // eigene Player aus Spotifys Liste gefallen, wird er erst neu verbunden;
  // Spotify vergibt dabei eine neue ID, die asynchron ueber "ready" kommt.
  // Liefert die Geraete-ID oder null.
  const holeHierher = useCallback(async (grund = "auto", play = false) => {
    if (!playerRef.current) return null;
    const aktiviere = async () => {
      const id = sdkGeraetIdRef.current;
      if (!id) return false;
      if (!(await activateDevice({ id, name: PLAYER_NAME }, grund))) return false;
      if (play) await playerRef.current?.resume().catch(() => {});
      return true;
    };
    let ok = await aktiviere();
    if (!ok) {
      const alteId = sdkGeraetIdRef.current;
      letzterReconnectRef.current = 0; // hier zaehlt jeder Versuch
      await reconnectPlayer();
      for (let i = 0; i < 12; i++) {
        const id = sdkGeraetIdRef.current;
        if (id && id !== alteId) break;
        await new Promise((r) => setTimeout(r, 500));
      }
      // Spotify braucht nach "ready" einen Moment, bis das Geraet gelistet ist
      for (let versuch = 0; versuch < 3 && !ok; versuch++) {
        ok = await aktiviere();
        if (!ok) await new Promise((r) => setTimeout(r, 1000));
      }
    }
    if (!ok) {
      logEvent("geraet", "Rueckholen nicht moeglich", { player: sdkGeraetIdRef.current ? "da" : "fehlt" });
      return null;
    }
    setGeraetVerschwunden(false);
    setDeviceError(null);
    logEvent("geraet", "Wiedergabe hierher zurueckgeholt", { grund });
    return sdkGeraetIdRef.current;
  }, [activateDevice, reconnectPlayer]);

  // Laeuft ueberhaupt ein Spiel? Nur dann darf sich die Seite als
  // Wiedergabegeraet bei Spotify anmelden, Geraete beobachten oder gar die
  // Wiedergabe an sich ziehen. Nach dem Beenden (FINISHED) hing der Player
  // sonst weiter in Spotifys Geraeteliste — und griff sich Stunden spaeter
  // beim privaten Musikhoeren die Wiedergabe samt Playlist.
  const spielAktiv = gameState === "SETUP" || gameState === "PLAYING";

  // --- GERÄTE-BEOBACHTUNG ---
  // Schreibt mit, WANN das eigene Gerät aus Spotifys Geräteliste fällt.
  // Genau diese Zeitspanne ("seit dem Pausieren vergangen: 38s") entscheidet,
  // ob ein kleiner Weck-Impuls reicht oder ob nur durchgehendes Abspielen hilft.
  const letzteGeraeteSignaturRef = React.useRef("");
  const fehltInFolgeRef = React.useRef(0);
  const beobachteGeraete = useCallback(async () => {
    try {
      const res = await spotifyFetch("/api/spotify/devices");
      if (!res.ok) return;
      const data = await res.json();
      const list = data.devices || [];
      const merkId = activeDeviceIdRef.current || localStorage.getItem(LAST_DEVICE_KEY);
      const merkName = localStorage.getItem(LAST_DEVICE_NAME_KEY);
      const eigenesDa = list.some((d) => d.id === merkId || (merkName && d.name === merkName));

      // Der eigene Player gilt als bereit, steht aber nicht mehr in Spotifys
      // Liste? Dann ist seine Verbindung gestorben — neu aufbauen, sonst ist
      // das Quiz-Gerät unsichtbar und nicht auswählbar.
      // Nicht beim ersten Fehlen: Spotify listet einen frisch bereiten Player
      // erst nach 1–2 s, und reconnectPlayer trennt erst — ein Fehlalarm
      // haette einen intakten Player (mitten im Song) abgerissen. Deshalb:
      // Karenzzeit nach "bereit", zweimal in Folge fehlend, und nicht, solange
      // der Player selbst gerade abspielt. Steht VOR dem Signatur-Abbruch
      // unten, sonst zaehlte "zweimal in Folge" bei gleicher Liste nie.
      const eigenerPlayerGelistet =
        !sdkGeraetIdRef.current || list.some((d) => d.id === sdkGeraetIdRef.current);
      if (playerRef.current && !eigenerPlayerGelistet) {
        const frisch = Date.now() - sdkBereitSeitRef.current < 10000;
        if (!frisch) fehltInFolgeRef.current += 1;
        let spieltGerade = false;
        try {
          const stand = await playerRef.current.getCurrentState();
          spieltGerade = !!stand && !stand.paused;
        } catch (e) { /* dann eben nicht */ }
        if (!spieltGerade && fehltInFolgeRef.current >= 2) {
          logEvent("player", "nicht mehr registriert — verbinde neu");
          fehltInFolgeRef.current = 0;
          reconnectPlayer();
        }
      } else {
        fehltInFolgeRef.current = 0;
      }

      const signatur =
        list.map((d) => `${d.name}${d.is_active ? "*" : ""}`).sort().join("|") +
        (eigenesDa ? "+" : "-");
      if (signatur === letzteGeraeteSignaturRef.current) return;
      letzteGeraeteSignaturRef.current = signatur;

      const seitPause = pausiertSeitRef.current
        ? Math.round((Date.now() - pausiertSeitRef.current) / 1000)
        : null;

      logEvent("geraeteliste", eigenesDa ? "geaendert" : "EIGENES GERAET WEG", {
        liste: list.map((d) => d.name + (d.is_active ? " (aktiv)" : "")).join(", ") || "leer",
        gemerkt: merkName || merkId || "-",
        ...(seitPause === null ? {} : { seitPauseSek: seitPause }),
      });
    } catch (e) { /* Protokoll darf nie stoeren */ }
  }, [spotifyFetch, reconnectPlayer]);

  useEffect(() => {
    if (!token || !spielAktiv) return;
    beobachteGeraete();
    const id = setInterval(() => {
      if (document.visibilityState === "hidden") return;
      beobachteGeraete();
    }, 20000);
    return () => clearInterval(id);
  }, [token, spielAktiv, beobachteGeraete]);

  // --- WIEDERGABE IM BROWSER: Player aufbauen ---
  //
  // Genau EINMAL. Ein zweiter Player wäre ein zweites Gerät in Spotifys Liste
  // und die Befehle gingen mal hierhin, mal dorthin. Der Ref-Riegel gilt auch
  // gegen den doppelten Effektlauf im StrictMode.
  //
  // Haengt an hatToken (ja/nein), NICHT am Token selbst: Beim Oeffnen der App
  // nach Stunden wird das Token oft in derselben Sekunde erneuert, in der der
  // Player startet. Der Tokenwechsel raeumte den Effekt ab, der halb gebaute
  // Player brach ab — und der Riegel blieb zu, bis zum naechsten Neuladen
  // gab es keinen Player (Protokoll 2026-10-05, 21:45). Die Musik lief dann
  // ueber die Spotify-App, und die friert iOS bei jeder Pause ein.
  // Das frische Token holt sich der Player ohnehin selbst (getOAuthToken).
  const hatToken = !!token;
  useEffect(() => {
    if (!hatToken || !spielAktiv) return;
    if (sdkGestartetRef.current) return;
    sdkGestartetRef.current = true;

    // verworfen: dieser Lauf wurde abgebrochen, BEVOR sein Player stand.
    // Dann gibt das Aufraeumen den Riegel sofort frei (der naechste Lauf darf
    // gleich bauen), und alles, was dieser Lauf spaeter noch meldet, zaehlt
    // nicht mehr — sonst ueberschrieb das "ready" eines verworfenen Players
    // die Geraete-ID des neuen. Vorher oeffnete erst der alte Lauf am Ende
    // den Riegel, der neue hatte da schon aufgegeben: kein Player bis zum
    // Neuladen.
    let verworfen = false;
    let fertig = false;
    let player = null;

    (async () => {
      try {
        const Spotify = await ladeSpotifySdk();
        if (verworfen) return;

        player = new Spotify.Player({
          name: PLAYER_NAME,
          // Das SDK holt sich das Token selbst — und zwar jedes Mal neu, wenn
          // es eins braucht. Deshalb hier NICHT das Token von aussen
          // einfrieren, sondern aus der Ref lesen und vorher auffrischen.
          getOAuthToken: async (cb) => {
            try {
              if (tokenExpiryRef.current && Date.now() > tokenExpiryRef.current - 60000) {
                await refreshSpotifyToken();
              }
            } catch (e) { /* dann eben mit dem alten versuchen */ }
            cb(tokenRef.current);
          },
          volume: 0.8,
        });

        player.addListener("ready", ({ device_id }) => {
          if (verworfen) return;
          // NICHT sdkGeraetIdRef nehmen: "not_ready" raeumt die ID vorher weg,
          // und genau der Fall (offline, dann mit neuer ID zurueck) ist der,
          // in dem die Merker nachgezogen werden muessen.
          const alteId = letzteSdkIdRef.current;
          sdkGeraetIdRef.current = device_id;
          letzteSdkIdRef.current = device_id;
          setSdkGeraetId(device_id);
          setSdkFehler(null);

          // Nach einer Neuverbindung vergibt Spotify eine NEUE device_id.
          // Zeigten unsere Merker noch auf die alte, liefen alle Befehle mit
          // ?device_id=… ins Leere: Start und Stopp klappten weiter (die gehen
          // direkt an den Player), aber "nächster Song" tat nichts — es lief
          // immer derselbe Titel, bis jemand in der Spotify-App eingriff.
          if (alteId && alteId !== device_id) {
            if (activeDeviceIdRef.current === alteId) setActiveDeviceId(device_id);
            try {
              if (localStorage.getItem(GEWAEHLT_KEY) === alteId) {
                localStorage.setItem(GEWAEHLT_KEY, device_id);
              }
              if (localStorage.getItem(LAST_DEVICE_KEY) === alteId) {
                localStorage.setItem(LAST_DEVICE_KEY, device_id);
              }
            } catch (e) { /* Speicher voll oder gesperrt — egal */ }
            logEvent("player", "neue Geraete-ID uebernommen");
          }
          // Nach einer Neuverbindung darf die Wiedergabe wieder hierher
          // geholt werden. Der Zaehler stoesst das an — sich allein auf die
          // Geraete-ID zu verlassen reicht nicht: kommt nach dem Reconnect
          // dieselbe ID zurueck, aendert sich nichts und der Effekt liefe nie.
          uebernahmeVersuchtRef.current = false;
          sdkBereitSeitRef.current = Date.now();
          setSdkBereitZaehler((n) => n + 1);
          logEvent("player", "bereit");
        });

        // Jeder Titelwechsel schreibt den echten Song in die
        // Systemanzeige (Dynamic Island, Sperrbildschirm). Direkt wieder
        // ueberschreiben — sonst steht die Loesung neben dem Quiz.
        player.addListener("player_state_changed", () => {
          verbergeSongInfo();
        });

        player.addListener("not_ready", () => {
          if (verworfen) return;
          logEvent("player", "offline");
          sdkGeraetIdRef.current = null;
          setSdkGeraetId(null);
          // Nicht liegen lassen: die Geräte-Beobachtung merkt das und
          // verbindet neu, sobald die Seite wieder sichtbar ist.
        });

        [
          "initialization_error",
          "authentication_error",
          "account_error",
          "playback_error",
        ].forEach((art) => {
          player.addListener(art, ({ message }) => {
            if (verworfen) return;
            logEvent("player", art, { meldung: message });
            setSdkFehler(SDK_FEHLERTEXTE[art] || art);
            // Der `streaming`-Scope kam erst mit dieser Version dazu. Wer noch
            // mit einer älteren Anmeldung unterwegs ist, hat ihn nicht — das
            // SDK lehnt dann ab. Ein Neuverbinden holt ihn, ohne Punkte oder
            // Verlauf zu verlieren.
            if (art === "authentication_error") setSdkBrauchtNeuanmeldung(true);
          });
        });

        const verbunden = await player.connect();
        if (verworfen) {
          player.disconnect();
          return;
        }
        fertig = true;
        playerRef.current = verbunden ? player : null;
        logEvent("player", verbunden ? "verbunden" : "Verbindung abgelehnt");
        if (!verbunden) {
          // Riegel wieder oeffnen, sonst gab es bis zum Spielende keinen
          // zweiten Versuch. Der naechste Lauf des Effekts (frisches Token,
          // neues Spiel) baut den Player neu auf.
          try {
            player.disconnect();
          } catch (e) { /* war nie verbunden */ }
          sdkGestartetRef.current = false;
        }
      } catch (err) {
        if (verworfen) return;
        fertig = true;
        logEvent("player", "Start fehlgeschlagen", { fehler: err.message });
        setSdkFehler(SDK_FEHLERTEXTE[err.message] || "Wiedergabe im Browser nicht möglich.");
        sdkGestartetRef.current = false;
      }
    })();

    return () => {
      if (!fertig) {
        verworfen = true;
        sdkGestartetRef.current = false;
      }
      // Bewusst KEIN disconnect beim normalen Aufräumen: der Effekt hängt an
      // Login/Spielphase, ein Wechsel würde sonst mitten im Spiel das Gerät
      // abmelden. Abgebaut wird beim Spielende und beim Abmelden.
    };
  }, [hatToken, spielAktiv, refreshSpotifyToken]);

  // iOS lässt Ton nur nach einer echten Nutzergeste zu. Das SDK hat dafür
  // activateElement(): einmal beim ersten Antippen aufrufen, danach darf die
  // App die Wiedergabe auch aus einem Timeout heraus starten. Ohne das bleibt
  // es beim ersten Song still — und zwar genau auf dem iPhone.
  const audioFreigegebenRef = React.useRef(false);
  useEffect(() => {
    const freigeben = () => {
      if (audioFreigegebenRef.current) return;
      const p = playerRef.current;
      if (!p || typeof p.activateElement !== "function") return;
      audioFreigegebenRef.current = true;
      p.activateElement()
        .then(() => {
          logEvent("player", "Audio freigegeben");
          verbergeSongInfo();
        })
        .catch((e) => {
          audioFreigegebenRef.current = false;
          logEvent("player", "Audio-Freigabe abgelehnt", { fehler: e.message });
        });
    };
    window.addEventListener("pointerdown", freigeben);
    window.addEventListener("keydown", freigeben);
    return () => {
      window.removeEventListener("pointerdown", freigeben);
      window.removeEventListener("keydown", freigeben);
    };
  }, []);

  // Spiel vorbei: Geraet abmelden.
  //
  // Ohne das blieb der Quiz-Player in Spotifys Geraeteliste stehen,
  // solange der Tab offen war. Eine Stunde spaeter, beim privaten
  // Musikhoeren, verband sich der Player nach einem Aussetzer neu, meldete
  // "ready" — und die Automatik zog die Wiedergabe samt Playlist auf die
  // Quiz-Seite. Beendet heisst beendet: Verbindung zu, Geraet weg.
  // Beim naechsten Spiel baut der Effekt oben alles wieder auf.
  useEffect(() => {
    if (spielAktiv) return;
    const p = playerRef.current;
    if (!p) return;
    logEvent("player", "Spiel beendet — Geraet abgemeldet");
    try {
      p.disconnect();
    } catch (e) { /* schon zu */ }
    playerRef.current = null;
    sdkGeraetIdRef.current = null;
    setSdkGeraetId(null);
    // Damit ein neues Spiel wieder einen Player aufbauen darf — und die
    // Ton-Freigabe fuer den neuen Player erneut eingeholt wird.
    sdkGestartetRef.current = false;
    uebernahmeVersuchtRef.current = false;
    audioFreigegebenRef.current = false;
  }, [spielAktiv]);

  // Wiedergabe automatisch hierher holen, sobald der Player bereit ist.
  //
  // Beim ersten Test blieb genau das aus: das Gerät stand in der Liste, aber
  // aktiv war weiter die Spotify-App auf dem iPhone — und damit war das alte
  // Problem unverändert da. Einen Knopf, den man erst finden muss, gibt es
  // deshalb nicht mehr.
  //
  // Läuft die Musik gerade auf einem Laptop oder einer Box, wird sie NICHT
  // weggenommen — dort funktioniert alles, und der Ton soll nicht plötzlich
  // aus dem Handy kommen.
  useEffect(() => {
    // NUR im laufenden Spiel. Ohne diese Bedingung holte sich die Seite die
    // Wiedergabe auch dann zurueck, wenn laengst niemand mehr quizzt: der
    // Player verband sich nach einem Aussetzer neu, meldete "ready" — und
    // riss die private Musik auf ein anderes Geraet.
    if (gameState !== "PLAYING") return;
    if (!token || !sdkGeraetId || uebernahmeVersuchtRef.current) return;

    // Und nur, wenn das Quiz auch vor Augen liegt. Wer die Seite offen
    // liegen laesst und nebenbei privat Musik hoert, dem darf sie die
    // Wiedergabe nicht wegschnappen — genau das ist passiert, eine Stunde
    // nach dem letzten Blick aufs Quiz. Beim Zurueckkommen wird es
    // nachgeholt.
    if (document.visibilityState !== "visible") {
      const beiRueckkehr = () => {
        if (document.visibilityState !== "visible") return;
        document.removeEventListener("visibilitychange", beiRueckkehr);
        setSdkBereitZaehler((n) => n + 1);
      };
      document.addEventListener("visibilitychange", beiRueckkehr);
      return () => document.removeEventListener("visibilitychange", beiRueckkehr);
    }

    uebernahmeVersuchtRef.current = true;

    (async () => {
      // Spotify braucht ein, zwei Sekunden, bis ein frisch verbundener Player
      // in der Geräteliste auftaucht. Beim ersten Versuch stand dort deshalb
      // "eigenes Geraet nicht in der Liste" — und die Übernahme unterblieb
      // für den Rest der Sitzung. Also: nachfassen statt aufgeben.
      let liste = [];
      let eigenes = null;
      for (let versuch = 1; versuch <= 4; versuch++) {
        liste = await loadDevices();
        eigenes = liste.find((d) => d.id === sdkGeraetId);
        if (eigenes) break;
        await new Promise((r) => setTimeout(r, 1200));
      }
      if (!eigenes) {
        logEvent("player", "eigenes Geraet nicht in der Liste");
        // Nicht endgültig aufgeben: beim nächsten Bereit-Signal neu versuchen.
        uebernahmeVersuchtRef.current = false;
        return;
      }
      const aktiv = liste.find((d) => d.is_active);

      if (aktiv && aktiv.id === sdkGeraetId) {
        merkeGeraet(eigenes);
        logEvent("player", "spielt bereits hier");
        return;
      }

      // Hat der Host zuletzt bewusst ein anderes Gerät gewählt (Box, Laptop)
      // und ist das noch da, bleibt es dabei. Automatik darf eine Entscheidung
      // nicht überstimmen — auch nicht nach einem Neuladen.
      let gewaehlt = null;
      try {
        gewaehlt = localStorage.getItem(GEWAEHLT_KEY);
      } catch (e) { /* egal */ }
      if (gewaehlt && gewaehlt !== sdkGeraetId) {
        const nochDa = liste.find((d) => d.id === gewaehlt);
        // Ein frueherer Quiz-Player (vor dem Neuladen) ist keine Wahl, die
        // zaehlt — das war ja diese Seite, nur mit alter ID.
        if (nochDa && !istQuizPlayer(nochDa.name) && !["Smartphone", "Tablet"].includes(nochDa.type)) {
          logEvent("player", "Wahl des Hosts bleibt", { geraet: nochDa.name });
          return;
        }
      }

      // Nur übernehmen, wenn nichts läuft oder die Wiedergabe auf einem
      // Handy hängt — genau dort bricht sie sonst gleich wieder ab.
      const handy = aktiv && ["Smartphone", "Tablet"].includes(aktiv.type);
      // Aktiv ist ein alter Quiz-Player dieser Seite (vor dem Neuladen, mit
      // alter ID): der lebt nicht mehr, also uebernehmen. Vorher galt er als
      // "fremdes Geraet" und die Seite traute sich nicht (Protokoll
      // 2026-10-05, 22:13: "laeuft woanders, nicht uebernommen").
      const geist = aktiv && istQuizPlayer(aktiv.name);
      if (aktiv && !handy && !geist) {
        logEvent("player", "laeuft woanders, nicht uebernommen", { aktiv: aktiv.name });
        return;
      }

      const ok = await activateDevice(eigenes, "auto");
      logEvent("player", ok ? "Wiedergabe hierher geholt" : "Uebernahme fehlgeschlagen", {
        vorher: aktiv ? aktiv.name : "nichts aktiv",
      });
    })();
  }, [token, gameState, sdkGeraetId, sdkBereitZaehler, loadDevices, activateDevice, merkeGeraet]);

  /** Läuft die Wiedergabe gerade auf unserem eigenen Browser-Gerät? */
  const spieltHier = useCallback(
    () => !!playerRef.current && !!sdkGeraetIdRef.current &&
      activeDeviceIdRef.current === sdkGeraetIdRef.current,
    []
  );

  // --- SPOTIFY STEUERUNG ---
  const controlSpotify = useCallback(async (command, body = {}) => {
    if (!token) return;

    // Läuft es hier im Browser, direkt am Player steuern statt über Spotifys
    // Server. Kein Netzweg, keine 404/403 wegen eingeschlafener Geräte —
    // und vor allem: dieses Gerät kann nicht verschwinden.
    if (spieltHier() && (command === "play" || command === "pause" || command === "next")) {
      try {
        const p = playerRef.current;
        if (command === "play") await p.resume();
        else if (command === "pause") await p.pause();
        else await p.nextTrack();
        // Das SDK traegt den echten Titel erst kurz nach dem Befehl in die
        // Systemanzeige ein — deshalb mehrfach nachfassen, sonst blitzt die
        // Loesung in der Dynamic Island auf.
        verbergeSongInfo();
        [400, 1200, 2500].forEach((ms) => setTimeout(verbergeSongInfo, ms));
        return;
      } catch (err) {
        // Fällt auf den normalen Weg zurück, statt die Runde steckenzulassen
        logEvent("player", "lokaler Befehl fehlgeschlagen", { befehl: command, fehler: err.message });
      }
    }

    try {
      let url = `/api/spotify/${command}`;
      let method = "POST"; // Standard

      // Play/Pause müssen PUT sein
      if (command === "play" || command === "pause") {
        method = "PUT";
      }

      // Gerät direkt adressieren. play?device_id aktiviert ein schlafendes Gerät
      // ebenso wie ein Transfer, ist aber ein Aufruf statt zwei — und setzt vor
      // allem NICHT die Wiedergabeposition zurück.
      if ((command === "play" || command === "pause" || command === "next") && activeDeviceId) {
        url = `/api/spotify/${command}?device_id=${encodeURIComponent(activeDeviceId)}`;
      }

      const options = {
        method: method,
        headers: {
          "Content-Type": "application/json"
        },
      };

      if (Object.keys(body).length > 0) {
        options.body = JSON.stringify(body);
      }

      const response = await spotifyFetch(url, options);

      if (!response.ok) {
        // 403 "Restriction violated" heißt bei Spotify schlicht: der Befehl
        // war überflüssig — Play auf laufender Musik, Pause auf pausierter.
        // Gilt für BEIDE Richtungen; vorher flog Pause als Fehler ins Log.
        if (response.status === 403 && (command === "play" || command === "pause")) {
          console.warn("Spotify ignoriert den Befehl (Zustand passt schon).");
          return;
        }

        // 404 = NO_ACTIVE_DEVICE: Gerät ist eingeschlafen. KEIN Auth-Problem.
        // 5xx = Spotify oder der Weg dorthin hat gehustet. In beiden Fällen
        // erst still selbst reaktivieren und den Befehl wiederholen; nur wenn
        // das scheitert, den User mit der Geräteauswahl behelligen.
        const erholbar = response.status === 404 || response.status >= 500;
        if (erholbar) {
          logEvent("spotify", response.status === 404 ? "kein aktives Geraet" : "Spotify-Aussetzer", {
            befehl: command,
            code: response.status,
          });
          const recoveredId = await ensureActiveDevice();
          if (recoveredId) {
            const retry = await spotifyFetch(
              `/api/spotify/${command}?device_id=${encodeURIComponent(recoveredId)}`,
              options
            );
            if (retry.ok || retry.status === 202 || retry.status === 204) {
              logEvent("spotify", "nach Erholung geklappt", { befehl: command });
              setSpotifyStatus("CONNECTED");
              return;
            }
            logEvent("spotify", "Wiederholung fehlgeschlagen", { befehl: command, code: retry.status });
          }
          // Letzter Ausweg vor dem Geraetedialog: die Quiz-Seite selbst. Das
          // gemerkte Geraet ist weg (typisch: Spotify-App auf dem iPhone nach
          // einer Pause eingefroren) — hier kann es immer weitergehen.
          // Nur bei 404 (Geraet weg), nicht bei einem kurzen Spotify-Aussetzer
          // (5xx) — und nicht, wenn der Host bewusst eine Box oder einen
          // Laptop gewaehlt hat: die soll nicht still aufs Handy wandern.
          let bewusstFest = false;
          try {
            const typ = localStorage.getItem(GEWAEHLT_TYP_KEY);
            const id = localStorage.getItem(GEWAEHLT_KEY);
            bewusstFest = !!id && id !== sdkGeraetIdRef.current && !!typ && !["Smartphone", "Tablet"].includes(typ);
          } catch (e) { /* egal */ }
          if (playerRef.current && response.status === 404 && !bewusstFest) {
            const hierId = await holeHierher("auto", command === "play");
            if (hierId) {
              if (command === "next") await playerRef.current?.nextTrack().catch(() => {});
              setSpotifyStatus("CONNECTED");
              return;
            }
          }
          logEvent("spotify", "Geraet nicht wiederherstellbar", { befehl: command });
          setActiveDeviceId(null);
          setSpotifyStatus("NO_DEVICE");
          // Direkt die Geräteliste zeigen: an dieser Stelle kann nur noch der
          // Mensch entscheiden, auf welchem Gerät es weitergehen soll.
          setShowDeviceModal(true);
          loadDevices();
          return;
        }
        throw new Error(`Spotify Error ${response.status}`);
      }

    } catch (err) {
      logEvent("spotify", "Befehl fehlgeschlagen", { befehl: command, fehler: err.message });
      console.error("Spotify Control Warning:", err.message);
    }
  }, [token, activeDeviceId, spotifyFetch, loadDevices, ensureActiveDevice, spieltHier, holeHierher]);

  // Spiegel der Werte, die fetchCurrentSong nur LIEST. Lägen sie in den Deps,
  // bekäme fetchCurrentSong bei jedem Abruf eine neue Identität — und würde damit
  // handleStopMusic und den Timer-Effekt mit neu aufsetzen (Timer blieb stehen).
  const currentSongIdRef = React.useRef(null);
  const currentPlaylistUriRef = React.useRef(null);
  const playedSongsRef = React.useRef([]);
  const playlistWarningMutedRef = React.useRef(false);

  useEffect(() => { currentSongIdRef.current = currentSongId; }, [currentSongId]);
  useEffect(() => { currentPlaylistUriRef.current = currentPlaylistUri; }, [currentPlaylistUri]);
  useEffect(() => { playedSongsRef.current = playedSongs; }, [playedSongs]);
  useEffect(() => { playlistWarningMutedRef.current = playlistWarningMuted; }, [playlistWarningMuted]);

  const fetchCurrentSong = useCallback(
    async (accessToken, forceUpdate = false, expectedDifferentFromId = null) => {
      try {
        const response = await spotifyFetch("/api/spotify/current");

        if (response.status === 200) {
          const data = await response.json();
          if (data && data.item) {
            if (data.device) {
              merkeGeraet(data.device);
            }

            const newSongId = data.item.id;

            // Falls wir darauf warten, dass ein *neuer* Song geladen ist
            if (expectedDifferentFromId && newSongId === expectedDifferentFromId) {
              return false;
            }

            const isSameSong = newSongId === currentSongIdRef.current;

            if (!forceUpdate && isSameSong) {
              return false;
            }

            // Playlist-Tracking NUR bei echtem Songwechsel.
            // Der 3s-Poll während der Wiedergabe ruft mit forceUpdate=true auf, um
            // die Songdaten frisch zu halten. Lief das hier mit durch, sah der gerade
            // laufende Song sich selbst in playedSongs und löste "WIEDERHOLUNG!" aus —
            // zuverlässig ein paar Sekunden nach dem allerersten Song.
            const newContextUri = data.context ? data.context.uri : null;
            const tracking = decideSongTracking({
              isSameSong,
              newContextUri,
              prevContextUri: currentPlaylistUriRef.current,
              playedSongs: playedSongsRef.current,
              songId: newSongId,
              warningMuted: playlistWarningMutedRef.current,
            });

            if (tracking === "reset") {
              currentPlaylistUriRef.current = newContextUri;
              playedSongsRef.current = [newSongId];
              playlistWarningMutedRef.current = false;
              setCurrentPlaylistUri(newContextUri);
              setPlayedSongs([newSongId]);
              setPlaylistWarningMuted(false);
            } else if (tracking === "append") {
              playedSongsRef.current = [...playedSongsRef.current, newSongId];
              setPlayedSongs(playedSongsRef.current);
            } else if (tracking === "warn") {
              setShowRepeatWarning(true);
            }

            currentSongIdRef.current = newSongId;
            setCurrentSongId(newSongId);
            setIsSongLoading(false);

            // Defensiv: lokale Dateien und Podcast-Folgen liefern kein
            // vollstaendiges album-Objekt. Ein Zugriff ins Leere flog vorher
            // in den catch — die Songdaten blieben dann fuer immer auf
            // "Lade Song...", und die Runde liess sich nicht mehr aufloesen.
            const album = data.item.album || {};
            setSongData({
              title: data.item.name || "Unbekannter Titel",
              artist: Array.isArray(data.item.artists)
                ? data.item.artists.map((a) => a.name).join(", ")
                : data.item.show?.name || "Unbekannter Interpret",
              year: (album.release_date || "").split("-")[0],
              album: album.name || "",
              cover: album.images?.[0]?.url || data.item.images?.[0]?.url || null,
            });
            return true;
          }
        }
      } catch (err) {
        console.error("Fehler beim Song-Abruf:", err);
      }
      return false;
    },
    [spotifyFetch, merkeGeraet]
  );

  const handleStopMusic = useCallback(() => {
    // 1. Timer stoppen (Interval, nicht Timeout — sonst lief er nach STOPP weiter)
    if (timerRef.current) clearInterval(timerRef.current);

    // Restzeit sichern, damit "Nochmal hören" an derselben Stelle weiterläuft.
    // 0 = war schon abgelaufen -> beim Weiterhören gilt dann kein Limit mehr.
    timerRemainingMsRef.current = remainingFromDeadline(timerDeadlineRef.current, Date.now());
    timerDeadlineRef.current = null;

    // 2. Musik bei Spotify pausieren
    pausiertSeitRef.current = Date.now();
    logEvent("wiedergabe", "pausiert");
    controlSpotify("pause");

    // 3. Daten aktualisieren (damit Cover bereitsteht, falls man es sehen WILL)
    if (token) fetchCurrentSong(token);

    // 4. Status ändern -> Zeigt die Buttons ("Weiterhören", "Bewerten")
    setRoundStage("SOLVED");

    // 5. KORREKTUR: Overlay muss AUS bleiben!
    // Es geht nur an, wenn du den "Lösung anzeigen" Button gedrückt hältst.
    setShowSolution(false);
  }, [controlSpotify, token, fetchCurrentSong]);

  // --- KEEP-ALIVE ---
  // Hielt vorher DREI parallele 15s-Intervalle offen (zwei identische Volume-Nudges
  // plus einen SOLVED-Ping), die sich gegenseitig überlappten. Jetzt genau eines.
  useEffect(() => {
    if (!token || !spielAktiv) return;

    const keepAlive = async () => {
      // Im Hintergrund-Tab nichts tun — Spotify limitiert sonst irgendwann.
      if (document.visibilityState === "hidden") return;

      try {
        // Nur noch ein Status-Ping. Der fruehere Lautstaerke-Wackler sollte
        // fremde Geraete wach halten, hat das nachweislich nicht geschafft
        // (iOS-Spotify meldet ohnehin supports_volume: false und gibt 403)
        // und stellte bei jedem Aussetzer die Lautstaerke des Hosts um.
        const res = await spotifyFetch("/api/spotify/current");
        if (res.status === 200) {
          const data = await res.json();
          if (data.device?.id && !activeDeviceId) setActiveDeviceId(data.device.id);
        }
      } catch (e) {
        logEvent("wachhalten", "Keep-Alive fehlgeschlagen", { fehler: e.message });
        console.warn("Keep-Alive fehlgeschlagen (Gerät evtl. offline)");
      }
    };

    const interval = setInterval(keepAlive, 15000);
    return () => clearInterval(interval);
  }, [token, activeDeviceId, spielAktiv, spotifyFetch]);

  // Periodic song check while PLAYING (so solution is always updated before STOP)
  useEffect(() => {
    if (!token || roundStage !== "PLAYING") return;
    const interval = setInterval(() => {
      fetchCurrentSong(token, true);
    }, 3000);
    return () => clearInterval(interval);
  }, [token, roundStage, fetchCurrentSong]);

  // Proaktiver Refresh 5 Min vor Ablauf.
  // Zusätzlich getriggert, wenn der Tab wieder sichtbar wird oder das Netz zurückkommt:
  // Nach Handy-Standby laufen Intervalle nicht weiter, das Token wäre sonst abgelaufen.
  useEffect(() => {
    if (!token || !tokenExpiry || !refreshToken) return;

    const checkExpiry = () => {
      if (Date.now() >= tokenExpiry - 300000) refreshSpotifyToken();
    };
    const onWake = () => {
      if (document.visibilityState === "visible") checkExpiry();
    };

    const timer = setInterval(checkExpiry, 30000);
    document.addEventListener("visibilitychange", onWake);
    window.addEventListener("online", checkExpiry);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onWake);
      window.removeEventListener("online", checkExpiry);
    };
  }, [token, tokenExpiry, refreshToken, refreshSpotifyToken]);

  // handleStopMusic per Ref, damit der Timer-Effekt es NICHT in den Deps braucht.
  // Vorher: jeder Song-Abruf gab handleStopMusic eine neue Identität, der Effekt
  // lief neu, das Cleanup killte den laufenden 1-Sekunden-Timeout — und weil während
  // "Ich bin bereit" alle 600ms gepollt wurde, kam der Timer sekundenlang nicht vom Fleck.
  const handleStopMusicRef = React.useRef(handleStopMusic);
  useEffect(() => { handleStopMusicRef.current = handleStopMusic; }, [handleStopMusic]);

  // TIMER LOGIK
  // Hängt NUR an roundStage. Vorher stand `timer` und `handleStopMusic` in den Deps:
  // jeder Song-Abruf setzte den laufenden 1-Sekunden-Timeout zurück, der Countdown
  // blieb dadurch die ersten Sekunden stehen.
  useEffect(() => {
    if (roundStage !== "PLAYING" || timerDeadlineRef.current === null) return;

    const tick = () => {
      const deadline = timerDeadlineRef.current;
      if (deadline === null) return;
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      setTimer(remaining);
      if (remaining === 0) {
        timerDeadlineRef.current = null;
        handleStopMusicRef.current();
      }
    };

    tick();
    timerRef.current = setInterval(tick, 250);
    return () => clearInterval(timerRef.current);
  }, [roundStage]);

  // --- WAKE LOCK ---
  // Gilt für ALLE Geräte im Spiel, nicht nur für den Host: Mitspieler sollen
  // nicht alle 30 Sekunden das Handy entsperren müssen, um den Buzzer zu
  // sehen. Beim Host hält es zusätzlich CPU und Spotify-Gerät wach.
  //
  // Wichtig: Das Betriebssystem gibt die Sperre beim Sperrbildschirm oder
  // App-Wechsel von sich aus frei — sie muss danach NEU angefordert werden,
  // sonst gilt sie nur bis zum ersten Wegdrücken.
  // Nach dem Spiel darf das Display wieder schlafen. Vorher blieb die Sperre
  // stehen, solange der Tab offen war — der Bildschirm ging Stunden nach dem
  // Quiz nicht mehr von selbst aus.
  const keepScreenAwake =
    spielAktiv ||
    (screen !== null && room.room?.game?.phase !== "FINISHED");
  useEffect(() => {
    if (!keepScreenAwake || !("wakeLock" in navigator)) return;

    let sentinel = null;
    let abgebrochen = false;
    // Beim Zurückkommen feuern visibilitychange, focus und pageshow fast
    // gleichzeitig. Ohne diese Sperre liefen drei Anforderungen parallel los
    // (alle vor der ersten Zuweisung) und es lagen drei Sperren gleichzeitig.
    let laeuft = null;
    let nachgefasst = false;
    // iOS gibt die Sperre nur nach einer echten Nutzergeste heraus. Nach dem
    // Zurueckkommen aus dem Hintergrund feuern visibilitychange, focus und
    // pageshow — jedes davon lief in denselben NotAllowedError. Im Protokoll
    // standen dadurch ein Dutzend Absagen in derselben Sekunde. Also: nach
    // einer Absage still bleiben und beim naechsten Antippen neu versuchen.
    let wartetAufGeste = false;
    let absageGemeldet = false;
    let letzterVersuch = 0;

    const requestWakeLock = async (ausGeste = false) => {
      if (abgebrochen) return;
      if (document.visibilityState !== "visible") return;
      if (sentinel && !sentinel.released) return;
      // Nach einer Absage nicht dauerfeuern — aber auch NICHT bis zur naechsten
      // Geste aufgeben: bleibt das Handy unberuehrt liegen, geht sonst das
      // Display aus und mit ihm die Wiedergabe. Also weiter versuchen, nur
      // selten (alle 20 s), und jede Geste zaehlt sofort.
      if (wartetAufGeste && !ausGeste && Date.now() - letzterVersuch < 20000) return;
      if (laeuft) return laeuft;
      letzterVersuch = Date.now();
      laeuft = (async () => {
      try {
        sentinel = await navigator.wakeLock.request("screen");
        if (abgebrochen) {
          sentinel.release().catch(() => { });
          return;
        }
        logEvent("wachbleiben", "aktiv");
        nachgefasst = false;
        wartetAufGeste = false;
        absageGemeldet = false;
        sentinel.addEventListener("release", () => {
          // Das Betriebssystem gibt die Sperre beim Sperrbildschirm frei.
          // Steht das oft im Protokoll, geht das Display trotzdem aus.
          logEvent("wachbleiben", "vom System freigegeben");
          sentinel = null;
        });
      } catch (err) {
        // Akkusparmodus oder kein sichtbarer Tab — kein Grund für Lärm.
        // Direkt nach dem Zurückkommen meldet iOS die Seite als sichtbar,
        // bevor sie es wirklich ist: die Anfrage scheitert mit
        // NotAllowedError. Ein zweiter Versuch kurz danach greift.
        // Nur die erste Absage protokollieren, bis es wieder klappt.
        if (!absageGemeldet) {
          absageGemeldet = true;
          logEvent("wachbleiben", "abgelehnt", { fehler: err.name });
        }
        console.warn("Wake Lock nicht möglich:", err.name);
        // Genau EIN zweiter Versuch nach kurzer Zeit — direkt nach dem
        // Zurueckkommen meldet iOS die Seite als sichtbar, bevor sie es
        // wirklich ist. Bleibt es dabei, wartet die Sperre aufs Antippen.
        if (err.name === "NotAllowedError" && !abgebrochen && !nachgefasst) {
          nachgefasst = true;
          setTimeout(() => requestWakeLock(true), 900);
        } else if (err.name === "NotAllowedError") {
          wartetAufGeste = true;
        }
      } finally {
        laeuft = null;
      }
      })();
      return laeuft;
    };

    requestWakeLock();

    const onWake = () => {
      if (document.visibilityState === "visible") requestWakeLock();
    };
    // Letztes Netz: sitzt die Sperre nicht, wird sie regelmaessig neu
    // angefordert. Ohne das blieb der Bildschirm nach einer einzigen Absage
    // dauerhaft ungesichert — und mit dem Display schlief die Wiedergabe ein.
    const nachfassen = setInterval(() => {
      if (sentinel && !sentinel.released) return;
      requestWakeLock();
    }, 20000);
    // Der Weg zurueck, wenn iOS abgelehnt hat: das naechste Antippen ist die
    // Nutzergeste, auf die das Betriebssystem wartet. STOPP, Buzzer oder ein
    // Tippen ins Leere genuegen — niemand muss etwas davon wissen.
    const onGeste = () => {
      if (wartetAufGeste) requestWakeLock(true);
    };
    document.addEventListener("visibilitychange", onWake);
    window.addEventListener("focus", onWake);
    window.addEventListener("pageshow", onWake);
    window.addEventListener("pointerdown", onGeste);
    window.addEventListener("keydown", onGeste);

    return () => {
      abgebrochen = true;
      clearInterval(nachfassen);
      document.removeEventListener("visibilitychange", onWake);
      window.removeEventListener("focus", onWake);
      window.removeEventListener("pageshow", onWake);
      window.removeEventListener("pointerdown", onGeste);
      window.removeEventListener("keydown", onGeste);
      if (sentinel) sentinel.release().catch(() => { });
    };
  }, [keepScreenAwake]);

  // "LÖSUNG HALTEN" ist ein Halte-Knopf. Wechselt der Bildschirm genau
  // während des Haltens — etwa weil ein Mitspieler sich in dem Moment den
  // Punkt gibt — kommt das pointerup nie beim Knopf an: das Overlay klebte
  // fest und man kam nur noch über "Beenden" heraus. Deshalb global lauschen.
  useEffect(() => {
    if (!showSolution) return;
    const schliessen = () => setShowSolution(false);
    window.addEventListener("pointerup", schliessen);
    window.addEventListener("pointercancel", schliessen);
    window.addEventListener("blur", schliessen);
    document.addEventListener("visibilitychange", schliessen);
    return () => {
      window.removeEventListener("pointerup", schliessen);
      window.removeEventListener("pointercancel", schliessen);
      window.removeEventListener("blur", schliessen);
      document.removeEventListener("visibilitychange", schliessen);
    };
  }, [showSolution]);

  // Zweites Netz: Jeder Phasenwechsel räumt hängengebliebene Overlays weg.
  useEffect(() => {
    setShowSolution(false);
  }, [roundStage, gameState]);


  // Escape schließt das oberste Overlay.
  useEffect(() => {
    const onEsc = (e) => {
      if (e.key !== "Escape") return;
      if (showHistoryModal) setShowHistoryModal(false);
      else if (showMobileScores) setShowMobileScores(false);
      else if (showSettings) setShowSettings(false);
      else if (showExitConfirm) setShowExitConfirm(false);
    };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [showHistoryModal, showMobileScores, showSettings, showExitConfirm]);

  // 2. BEI ÄNDERUNG: Spielstand automatisch speichern
  useEffect(() => {
    if (gameState !== "LOGIN") {
      const stateToSave = {
        players,
        activeTasks,
        playedSongs,
        currentPlaylistUri,
        token,
        refreshToken,
        tokenExpiry,
        authGrantedAt,
        matchHistory,
        roundCount,
        gameState,
        timeLimit,
        // Die laufende Runde gehoert dazu. Ohne sie stand der Host nach
        // jedem Neuladen wieder auf "NAECHSTE AUFGABE" und warf mit dem
        // naechsten Klick den gerade laufenden Song weg.
        roundStage,
        taskType,
        // Absoluter Zeitpunkt statt Restsekunden: nur so stimmt die
        // Restzeit auch, wenn zwischen Speichern und Laden Zeit vergeht.
        // Steht die Musik, gibt es keinen Zielzeitpunkt mehr — dann zaehlt
        // die eingefrorene Restzeit (auch nach einem zweiten Neuladen).
        timerDeadline: timerDeadlineRef.current,
        timerRestMs: timerRemainingMsRef.current,
        // Ohne den Modus fiel der Host nach jedem Neuladen auf "Klassisch"
        // zurueck. Damit endete stillschweigend jede Synchronisation in den
        // Raum: die Mitspieler-Handys standen auf dem zuletzt gesendeten
        // Bild fest, obwohl das Spiel weiterlief.
        gameMode,
      };
      localStorage.setItem("musicQuizState", JSON.stringify(stateToSave));
    }
    // timeLimit gehörte hier: es wurde gespeichert, stand aber nicht in den Deps,
    // eine reine Zeitlimit-Änderung wurde daher nie persistiert.
  }, [players, activeTasks, playedSongs, currentPlaylistUri, token, refreshToken, tokenExpiry, matchHistory, roundCount, gameState, timeLimit, authGrantedAt, gameMode, roundStage, taskType]);

  useEffect(() => {
    let savedGameState = null;

    const savedState = localStorage.getItem("musicQuizState");
    if (savedState) {
      try {
        const data = JSON.parse(savedState);
        if (data.players) setPlayers(data.players);
        if (data.activeTasks) setActiveTasks(data.activeTasks);
        if (data.playedSongs) setPlayedSongs(data.playedSongs);
        if (data.currentPlaylistUri) setCurrentPlaylistUri(data.currentPlaylistUri);
        // Anmeldung befristen: liegt die Erteilung zu lange zurueck, werden
        // die Tokens verworfen. Punkte und Verlauf bleiben erhalten.
        const grantedAt = data.authGrantedAt || null;
        const abgelaufen = grantedAt !== null && Date.now() - grantedAt > AUTH_MAX_AGE_MS;
        // Alte Spielstaende ohne authGrantedAt: Frist ab jetzt rechnen,
        // statt sie als unbegrenzt gueltig zu behandeln.
        if (abgelaufen) {
          console.warn("Gespeicherte Anmeldung ist aelter als 30 Tage — verworfen.");
          setAuthError("session_expired");
          // Laeuft noch ein Spiel, bleibt der Nutzer sonst ohne Hinweis darin
          // sitzen und wundert sich, warum Spotify nicht mehr reagiert.
          // Das Banner "Neu verbinden" erklaert es und behaelt Punkte/Verlauf.
          setNeedsReauth(true);
        } else {
          if (data.token) setToken(data.token);
          if (data.refreshToken) setRefreshToken(data.refreshToken);
          if (data.tokenExpiry) setTokenExpiry(data.tokenExpiry);
          const basis = grantedAt || Date.now();
          setAuthGrantedAt(basis);
          authGrantedAtRef.current = basis;
        }
        if (data.matchHistory) setMatchHistory(data.matchHistory);
        if (data.roundCount) setRoundCount(data.roundCount);
        if (data.gameState) {
          savedGameState = data.gameState;
          setGameState(data.gameState);
        }
        if (data.timeLimit !== undefined) {
          setTimeLimit(data.timeLimit);
        }
        if (data.gameMode) setGameMode(data.gameMode);

        // Laufende Runde zurueckholen. Ein Neuladen mitten im Song warf den
        // Host sonst auf "NAECHSTE AUFGABE" — der naechste Klick sprang zum
        // uebernaechsten Lied, obwohl gerade noch geraten wurde.
        if (data.gameState === "PLAYING" && data.roundStage) {
          if (data.taskType) setTaskType(data.taskType);
          // Nach dem Neuladen spielt nichts mehr: der Browser-Player ist neu
          // und steht. "PLAYING" waere gelogen — der Zwischenstand nach dem
          // Stoppen passt, dort gibt es "nochmal hoeren" und "aufloesen".
          if (data.roundStage === "PLAYING") {
            setRoundStage("SOLVED");
            // In der Jahres-Runde darf die Auswertung jetzt NICHT von selbst
            // loslaufen: wer noch nicht getippt hatte, verlöre seinen Tipp,
            // nur weil das Host-Handy neu geladen hat. Der Host loest aus.
            // Nur in der Jahres-Runde — sonst blieb der Merker stehen und die
            // naechste Jahres-Runde wertete nicht mehr von selbst aus.
            jahrAutoStoppRef.current = data.taskType === "YEAR";
          } else {
            setRoundStage(data.roundStage);
          }
          // Restzeit aus dem gemerkten Zielzeitpunkt. Ist sie abgelaufen,
          // laeuft der Song beim Weiterhoeren ohne Limit — wie nach STOPP.
          const rest = data.timerDeadline
            ? data.timerDeadline - Date.now()
            : data.timerRestMs || 0;
          timerRemainingMsRef.current = rest > 0 ? rest : 0;
          setTimer(rest > 0 ? Math.ceil(rest / 1000) : null);
        }

        console.log("Spielstand erfolgreich geladen!");
      } catch (e) {
        console.error("Fehler beim Laden des Spielstands", e);
      }
    }

    // Tokens kommen im Fragment (#), nicht im Query-String — bleiben so aus Server-Logs raus.
    const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : "";
    // Kein Rueckfall auf den Query-String mehr: /callback schreibt seit
    // 2026-07-29 ins Fragment, Tokens in der Query landen in Logs und Verlauf.
    const params = new URLSearchParams(hash);

    const errorFromUrl = params.get("error");
    if (errorFromUrl) {
      setAuthError(errorFromUrl);
      window.history.replaceState({}, "", "/");
      return;
    }

    const tokenFromUrl = params.get("token");
    if (tokenFromUrl) {
      applyTokens(tokenFromUrl, params.get("refresh_token"), params.get("expires_in"), true);

      // Beim Reconnect mitten im Spiel NICHT zurück ins Setup werfen.
      if (!savedGameState || savedGameState === "LOGIN") {
        setGameState("SETUP");
      }
      window.history.replaceState({}, "", "/");
    }
  }, [applyTokens]);

  useEffect(() => {
    // Auch das nur im laufenden Spiel: der Fehlschlag-Pfad ruft
    // ensureActiveDevice() — und das SCHREIBT bei Spotify (Transfer auf ein
    // anderes Geraet). Ausserhalb eines Spiels hat die Seite an der
    // Wiedergabe des Nutzers nichts zu suchen.
    if (!token || !spielAktiv) return;

    const checkStatus = async () => {
      // Im Hintergrund-Tab nicht pollen — spart Requests und Rate-Limit.
      if (document.visibilityState === "hidden") return;

      // Kein Netz ist kein Spotify-Problem — eigener Zustand statt "unterbrochen".
      if (navigator.onLine === false) {
        setSpotifyStatus("OFFLINE");
        return;
      }

      // Handys haben ständig kurze Aussetzer. Erst nach mehreren Fehlversuchen
      // rot zeigen — und vorher einmal still selbst reparieren.
      const fail = async () => {
        statusFailuresRef.current += 1;
        logEvent("status", "Abruf fehlgeschlagen", { versuch: statusFailuresRef.current });
        if (statusFailuresRef.current === 2) {
          setSpotifyStatus("RECONNECTING");
          const recovered = await ensureActiveDevice();
          if (recovered) {
            statusFailuresRef.current = 0;
            setSpotifyStatus("CONNECTED");
            return;
          }
        }
        if (statusFailuresRef.current >= 4) setSpotifyStatus("DISCONNECTED");
      };

      try {
        const response = await spotifyFetch("/api/spotify/current");
        if (response.status === 200) {
          statusFailuresRef.current = 0;
          setSpotifyStatus("CONNECTED");
        } else if (response.status === 204) {
          // 204 = Verbindung steht, es läuft nur (noch) nichts.
          statusFailuresRef.current = 0;
          setSpotifyStatus("NO_DEVICE");
        } else {
          await fail();
        }
      } catch (err) {
        await fail();
      }
    };

    // Zurück aus Standby/App-Wechsel: sofort prüfen UND das Gerät neu anmelden.
    // Genau hier verliert das Handy sonst die Verbindung.
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      // Wie lange war die Seite weg? Genau diese Lücke ist der Verdächtige:
      // in ihr laufen keine Timer, kein Keep-Alive, kein Token-Refresh.
      const weg = wegSeitRef.current ? Math.round((Date.now() - wegSeitRef.current) / 1000) : null;
      wegSeitRef.current = null;
      logEvent("sicht", "zurueck im Vordergrund", weg === null ? {} : { wegSek: weg });
      checkStatus();
      // Holt das gemerkte Geraet zurueck — ein schreibender Aufruf. Deshalb
      // nur, wenn wirklich gespielt wird (der Effekt laeuft ohnehin nur dann).
      ensureActiveDevice();
    };

    const onHidden = () => {
      if (document.visibilityState !== "hidden") return;
      wegSeitRef.current = Date.now();
      logEvent("sicht", "in den Hintergrund");
    };

    const onOffline = () => {
      logEvent("netz", "offline");
      checkStatus();
    };
    const onOnline = () => {
      logEvent("netz", "wieder online");
      onVisible();
    };

    checkStatus();
    const interval = setInterval(checkStatus, 10000);
    document.addEventListener("visibilitychange", onVisible);
    document.addEventListener("visibilitychange", onHidden);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener("pageshow", onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
      document.removeEventListener("visibilitychange", onHidden);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("pageshow", onVisible);
    };
  }, [token, spotifyFetch, ensureActiveDevice, spielAktiv]);

  // Banner "Gerät weg" erst nach ein paar Sekunden Dauerzustand. Direkt nach
  // "Ich bin bereit" meldet Spotify kurz 204 (nichts läuft) — ein Banner, das
  // dabei jedes Mal aufblitzt, ist schlimmer als keins.
  const [zeigeGeraeteBanner, setZeigeGeraeteBanner] = useState(false);
  const [geraeteSucheLaeuft, setGeraeteSucheLaeuft] = useState(false);
  useEffect(() => {
    const problem =
      !needsReauth &&
      (spotifyStatus === "DISCONNECTED" ||
        (spotifyStatus === "NO_DEVICE" && roundStage === "PLAYING"));
    if (!problem) {
      setZeigeGeraeteBanner(false);
      return;
    }
    const id = setTimeout(() => setZeigeGeraeteBanner(true), 4000);
    return () => clearTimeout(id);
  }, [spotifyStatus, needsReauth, roundStage]);

  // Jeder Statuswechsel ins Protokoll. Daraus lässt sich hinterher lesen,
  // ob zuerst das Gerät wegging oder zuerst die Verbindung.
  useEffect(() => {
    logEvent("status", spotifyStatus, {
      geraet: activeDeviceIdRef.current ? "gesetzt" : "keins",
    });
  }, [spotifyStatus]);

  // --- SPIEL-LOGIK ---
  // "Ich bin bereit!" laeuft gerade (pause -> next -> warten auf den neuen
  // Song). Ein zweiter Tipp in der Zeit schickte ein zweites "next" hinterher
  // und uebersprang einen Song.
  const bereitLaeuftRef = React.useRef(false);
  const [bereitLaeuft, setBereitLaeuft] = useState(false);
  const bereitFertig = () => {
    bereitLaeuftRef.current = false;
    setBereitLaeuft(false);
  };

  const prepareNextTask = () => {
    // Erstellt eine Liste nur mit den Tasks, die auf 'true' stehen
    const enabledTasks = Object.keys(activeTasks).filter(
      (task) => activeTasks[task]
    );

    // Falls aus Versehen alle ausgeschaltet wurden, nimm TITLE als Fallback
    const finalPool = enabledTasks.length > 0 ? enabledTasks : ["TITLE"];

    const randomTask = finalPool[Math.floor(Math.random() * finalPool.length)];

    setTaskType(randomTask);
    // Neuer Song erbt keine Restzeit aus der vorherigen Runde
    if (timerRef.current) clearInterval(timerRef.current);
    timerDeadlineRef.current = null;
    timerRemainingMsRef.current = 0;
    setTimer(null);
    setVotedPlayers([]);
    setSelbstGemeldet(null);
    setPunktEntfernt(false);
    setRoundStage("TASK");
    setShowSolution(false);
    setIsSongLoading(true);
    setRoundCount((prev) => prev + 1);
    bereitFertig();
    setSongData({ title: "Lade Song...", artist: "...", year: "...", album: "...", cover: null });
  };

  // Neu verbinden OHNE Datenverlust: Spielstand, Punkte und Verlauf bleiben in
  // localStorage stehen. Ist die Spotify-Session noch aktiv, ist das ein stiller
  // Redirect hin und zurück — kein erneutes Einloggen nötig.
  const handleReconnect = () => {
    window.location.href = "/login";
  };

  // Echtes Abmelden: löscht alles und erzwingt beim nächsten Login die Kontoauswahl.
  const handleLogout = () => {
    // Player abmelden, sonst bleibt das Gerät bis zum Schließen des Tabs in
    // Spotifys Liste stehen und der nächste Host wählt ein totes Gerät.
    try {
      if (playerRef.current) playerRef.current.disconnect();
    } catch (e) { /* egal, wir gehen sowieso */ }
    localStorage.clear();
    sessionStorage.clear();
    setToken(null);
    setGameState("LOGIN");
    // Harter Reload, damit alle Timer/Pings sicher stoppen
    window.location.href = "/";
  };

  // mode:
  //   "fresh"     — neuer Song, volles Zeitlimit
  //   "resume"    — nach STOPP weiterhören: Countdown läuft an der gestoppten
  //                 Stelle weiter. War er schon abgelaufen, gilt kein Limit mehr.
  //   "unlimited" — bewusst ohne Zeitlimit (z.B. nach der Bewertung)
  // "Ich bin bereit" startet nach einem Timeout, der Countdown-Effekt kann
  // parallel greifen — im Protokoll standen zwei starts in derselben Sekunde
  // und entsprechend zwei Play-Befehle. Der zweite bringt nichts und
  // produziert nur Fehler.
  const letzterStartRef = React.useRef(0);
  const handleStartMusic = useCallback((mode = "fresh") => {
    // Musik laeuft wieder: die Ausnahme "nach dem Neuladen nicht von selbst
    // auswerten" gilt nicht mehr
    jahrAutoStoppRef.current = false;
    if (Date.now() - letzterStartRef.current < 1200) {
      logEvent("wiedergabe", "Doppelstart verworfen", { modus: mode });
      return;
    }
    letzterStartRef.current = Date.now();

    const pauseDauer = pausiertSeitRef.current
      ? Math.round((Date.now() - pausiertSeitRef.current) / 1000)
      : null;
    pausiertSeitRef.current = null;
    logEvent("wiedergabe", "start", {
      modus: mode,
      ...(pauseDauer === null ? {} : { pauseWarSek: pauseDauer }),
    });
    // Holt controlSpotify das Geraet erst zurueck (bis zu ~10 s), darf die
    // Zeit nicht schon laufen: Zielzeitpunkt um die Verzoegerung verschieben.
    const startVersuch = Date.now();
    const meinStart = letzterStartRef.current;
    controlSpotify("play").then(() => {
      const verzug = Date.now() - startVersuch;
      if (verzug < 1500) return;
      if (letzterStartRef.current !== meinStart || timerDeadlineRef.current === null) return;
      timerDeadlineRef.current += verzug;
      logEvent("wiedergabe", "Start verzoegert, Zeit nachgezogen", { ms: verzug });
    });
    setRoundStage("PLAYING");

    const remainingMs = resolveStartDurationMs(mode, {
      timeLimit,
      taskType,
      savedRemainingMs: timerRemainingMsRef.current,
    });

    // Zielzeitpunkt statt Sekunden-Countdown: bleibt korrekt, auch wenn der
    // Browser Timer drosselt (dunkles Display, Tab im Hintergrund).
    timerDeadlineRef.current = remainingMs === null ? null : Date.now() + remainingMs;
    timerRemainingMsRef.current = 0;
    setTimer(remainingMs === null ? null : Math.ceil(remainingMs / 1000));
    if (mode === "fresh") setTimerGesamt(remainingMs === null ? null : Math.ceil(remainingMs / 1000));
  }, [controlSpotify, timeLimit, taskType]);


  // Leertaste = Start/Stopp. Muss NACH handleStartMusic stehen: die Dependency-Liste
  // wird beim Render ausgewertet, davor wäre es ein Zugriff vor der Initialisierung.
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Verhindert Leertaste-Funktion, wenn man gerade einen Namen eintippt
      const tag = event.target.tagName;
      if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;

      if (event.code === "Space") {
        event.preventDefault();

        if (roundStage === "READY") {
          handleStartMusic("fresh");
        } else if (roundStage === "PLAYING") {
          handleStopMusic();
        }
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [roundStage, handleStartMusic, handleStopMusic]);

  // Ein Verlaufseintrag für die gerade laufende Runde. playerIndex === null
  // heißt: niemand hat den Punkt bekommen.
  const buildHistoryEntry = (playerIndex, playerName) => ({
    id: Date.now() + "_" + Math.random().toString(36).slice(2, 6),
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    playerIndex: playerIndex,
    // Bindet den Eintrag an die PERSON statt an ihren Listenplatz: der
    // verschiebt sich, sobald jemand dazukommt oder rausfliegt.
    roomId: playerIndex === null ? null : players[playerIndex]?.roomId || null,
    playerName: playerName,
    song: {
      title: songData.title || "Unbekannter Titel",
      artist: songData.artist || "Unbekannter Interpret",
      year: songData.year || "",
      album: songData.album || "",
      cover: songData.cover || null
    },
    taskType: taskType,
    roundNumber: roundCount
  });

  // bleibeStehen: Punkt vergeben, aber NICHT gleich zum naechsten Song.
  // Meldet sich ein Mitspieler selbst als richtig, sahen alle Handys die
  // Loesung — nur der Host sprang sofort auf die naechste Aufgabe und bekam
  // sie nie zu Gesicht.
  const handleScore = async (playerIndex, forceNextSong = false, bleibeStehen = false) => {
    if (playerIndex !== null) {
      // Spielerliste kann sich zwischendurch geändert haben (Nachzügler,
      // Rauswurf). Ein Punkt ins Leere hätte die App weggerissen.
      const spieler = players[playerIndex];
      if (!spieler) return;

      // Runde ist entschieden — jetzt dürfen alle Handys die Lösung sehen.
      // Muss VOR prepareNextTask raus: danach steht im Raum-Objekt schon
      // die Lösung des nächsten Songs (bzw. gar keine).
      if (isBuzzerHost && !isSongLoading) room.revealToAll();

      // Wenn Modus YEAR: Prüfen ob Spieler schon gewählt wurde
      if (taskType === "YEAR") {
        if (votedPlayers.includes(playerIndex)) return; // Klick ignorieren
        setVotedPlayers([...votedPlayers, playerIndex]);
      }

      // [...players] ist nur eine flache Kopie — n[i].score += 1 hätte das
      // Original-Objekt mutiert (bricht Verlauf-Umbuchung und React-Vergleiche).
      setPlayers((prev) =>
        prev.map((p, idx) => (idx === playerIndex ? { ...p, score: p.score + 1 } : p))
      );

      const newEntry = buildHistoryEntry(
        playerIndex,
        spieler.name || `Spieler ${playerIndex + 1}`
      );
      setMatchHistory((prev) => [newEntry, ...prev]);

      if (taskType !== "YEAR" && !bleibeStehen) prepareNextTask();
    } else if (forceNextSong) {
      // Wichtig für dein zweites Problem:
      // Wir rufen NUR prepareNextTask auf.
      // Den "Next"-Befehl an Spotify senden wir erst beim Klick auf "Ich bin bereit"
      prepareNextTask();
    } else {
      // "Song weiterhören" nach der Bewertung: Lösung ist eh bekannt, kein Limit.
      setShowSolution(false);
      handleStartMusic("unlimited");
    }
  };

  /**
   * Runde beenden, ohne dass jemand den Punkt bekommt.
   *
   * - hält die Musik an (sonst läuft sie in den nächsten Song hinein)
   * - deckt die Lösung im Buzzer-Modus für ALLE auf
   * - schreibt die Runde trotzdem in den Verlauf
   */
  const skipRound = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerDeadlineRef.current = null;
    timerRemainingMsRef.current = 0;
    controlSpotify("pause");
    setShowSolution(false);

    // Erst auflösen, dann weiter. "Keiner weiß es" heißt ja gerade, dass alle
    // wissen wollen, was es war — direkt zum nächsten Song zu springen nimmt
    // der Runde die Pointe. Aus der Bewertung heraus geht es dann wirklich weiter.
    if (roundStage !== "JUDGE") {
      if (isBuzzerHost && !isSongLoading) room.revealToAll();
      setRoundStage("JUDGE");
      return;
    }

    // Steht die Runde schon im Verlauf (Punkt vergeben und wieder
    // abgewaehlt), nicht noch eine zweite "kein Punkt"-Zeile anlegen.
    const schonImVerlauf = matchHistory.some((e) => e.roundNumber === roundCount);
    if (!isSongLoading && !schonImVerlauf) {
      setMatchHistory((prev) => [buildHistoryEntry(null, null), ...prev]);
    }
    prepareNextTask();
  };

  // Wem gehoert der Punkt dieser Runde? Steht im Verlauf, nicht in einem
  // eigenen Zustand: der ueberlebt weder ein Neuladen noch eine neu
  // gemischte Spielerliste, und beides passiert mitten im Spiel.
  const punktAnIndex = React.useMemo(() => {
    const eintrag = matchHistory.find((e) => e.roundNumber === roundCount);
    if (!eintrag) return null;
    if (eintrag.roomId) {
      const idx = players.findIndex((p) => p.roomId === eintrag.roomId);
      return idx === -1 ? null : idx;
    }
    if (eintrag.playerIndex === null || eintrag.playerIndex === undefined) return null;
    return eintrag.playerIndex < players.length ? eintrag.playerIndex : null;
  }, [matchHistory, roundCount, players]);

  /**
   * Punkt der laufenden Runde vergeben ODER umbuchen.
   *
   * Beim ersten Mal wird er verbucht, jeder weitere Klick verschiebt ihn —
   * ueber denselben Weg wie die Korrektur im Verlauf, damit Punktestand und
   * Verlauf nicht auseinanderlaufen. Bei "Jahr" im klassischen Modus duerfen
   * mehrere gleichzeitig den Punkt bekommen; dort bleibt es beim Addieren.
   */
  const vergebePunkt = (i) => {
    const name = players[i]?.name || `Spieler ${i + 1}`;
    const eintragDerRunde = (idx) =>
      matchHistory.find(
        (e) => e.roundNumber === roundCount && (idx === undefined || e.playerIndex === idx)
      );

    // Klassische Jahres-Runde: mehrere duerfen den Punkt haben, jeder
    // einzeln an- und abwaehlbar.
    if (taskType === "YEAR" && !jahrErgebnis) {
      if (!votedPlayers.includes(i)) {
        handleScore(i);
        return;
      }
      const eintrag = eintragDerRunde(i);
      if (eintrag) handleDeleteHistoryEntry(eintrag.id);
      else setPlayers((prev) => prev.map((p, idx) => (idx === i ? { ...p, score: Math.max(0, p.score - 1) } : p)));
      setVotedPlayers((prev) => prev.filter((idx) => idx !== i));
      return;
    }

    // Nochmal derselbe Name: Punkt fuer diese Runde wieder wegnehmen.
    if (punktAnIndex === i) {
      const eintrag = eintragDerRunde();
      if (eintrag) {
        // Bucht auf "niemand" zurueck: zieht den Punkt ab und laesst die
        // Runde als "kein Punkt vergeben" im Verlauf stehen.
        handleReassignHistoryEntry(eintrag.id, null);
      } else {
        setPlayers((prev) =>
          prev.map((p, idx) => (idx === i ? { ...p, score: Math.max(0, p.score - 1) } : p))
        );
      }
      setSelbstGemeldet(null);
      setPunktEntfernt(true);
      return;
    }

    setPunktEntfernt(false);

    if (punktAnIndex === null) {
      // Steht die Runde schon im Verlauf (abgewaehlt oder "keiner wusste
      // es"), bekommt DIESER Eintrag den Punkt. Sonst haette dieselbe Runde
      // zwei Zeilen: einmal "niemand", einmal mit Namen.
      const vorhanden = eintragDerRunde();
      if (vorhanden) {
        handleReassignHistoryEntry(vorhanden.id, i);
      } else {
        handleScore(i, false, true);
      }
      setSelbstGemeldet(name);
      return;
    }

    // Umbuchen: der Eintrag dieser Runde traegt den Punkt.
    const eintrag = eintragDerRunde();
    if (eintrag) {
      handleReassignHistoryEntry(eintrag.id, i);
    } else {
      // Kein Eintrag gefunden (sollte nicht vorkommen) — dann wenigstens den
      // Punktestand geradeziehen, statt ihn doppelt zu vergeben.
      setPlayers((prev) =>
        prev.map((p, idx) => {
          if (idx === punktAnIndex) return { ...p, score: Math.max(0, p.score - 1) };
          if (idx === i) return { ...p, score: p.score + 1 };
          return p;
        })
      );
    }
    setSelbstGemeldet(name);
  };

  const finishRound = async (skipSong = true) => {
    if (skipSong) {
      // Ging die Jahres-Runde an niemanden, gehört sie trotzdem in den Verlauf.
      if (votedPlayers.length === 0) {
        skipRound();
        return;
      }
      // Wir skippen nicht hier, sondern wie besprochen erst bei "Bereit"
      prepareNextTask();
    } else {
      // Fallback: Gleicher Song nochmal
      setRoundStage("READY");
    }
  };

  // Song-Historie einer Runde. Muss beim Spielstart weg, sonst schlug die
  // "Wiederholung!"-Warnung schon beim ERSTEN Song an: playedSongs und
  // currentPlaylistUri werden aus localStorage wiederhergestellt, und bei
  // gleicher Playlist galt der erste Song sofort als schon gespielt.
  const resetPlaylistTracking = () => {
    playedSongsRef.current = [];
    currentPlaylistUriRef.current = null;
    playlistWarningMutedRef.current = false;
    currentSongIdRef.current = null;
    setPlayedSongs([]);
    setCurrentPlaylistUri(null);
    setPlaylistWarningMuted(false);
    setCurrentSongId(null);
    setShowRepeatWarning(false);
  };

  const startGame = async () => {
    resetPlaylistTracking();
    setGameState("PLAYING");
    prepareNextTask();
  };

  // --- BUZZER-MODUS: BEITRITT & LOBBY ---

  const handleEnterCode = async (code) => {
    setJoinBusy(true);
    const info = await room.enterRoom(code);
    setJoinBusy(false);
    if (info) setJoinInfo(info);
  };

  // QR-Code führt auf /?join=ABCD — direkt zur Namenseingabe, ohne Umweg
  // über den Login. Muss VOR allen frühen Returns stehen (Hook-Regeln).
  const joinHandledRef = React.useRef(false);
  useEffect(() => {
    if (joinHandledRef.current) return;
    const params = new URLSearchParams(window.location.search);
    // Der Code wird gemerkt, BEVOR die URL aufgeräumt wird. Lädt die Seite
    // dazwischen neu (Service-Worker-Übernahme, Standby, versehentlicher
    // Reload), wäre er sonst weg und man landete auf der Startseite.
    const fromUrl = params.get("join") || sessionStorage.getItem(PENDING_JOIN_KEY);
    if (!fromUrl || !/^[A-Za-z0-9]{4}$/.test(fromUrl)) return;

    joinHandledRef.current = true;
    const code = fromUrl.toUpperCase();
    sessionStorage.setItem(PENDING_JOIN_KEY, code);
    window.history.replaceState({}, "", "/");

    // Ein gescannter Code schlaegt eine gespeicherte Sitzung. Sonst landet
    // man beim naechsten Spieleabend wieder im Raum von gestern, statt in
    // dem, dessen QR-Code man gerade abfotografiert hat.
    const saved = loadRoomSession("player");
    if (saved && saved.code !== code) {
      room.leaveRoom();
    } else if (saved && saved.playerId) {
      // Derselbe Raum, Platz schon vorhanden: nicht neu beitreten. Sonst
      // haenge der gemerkte Code nach jedem Neuladen die Namensabfrage vor
      // das laufende Spiel — und der eigene Platz galt derweil als belegt.
      sessionStorage.removeItem(PENDING_JOIN_KEY);
      return;
    }

    setJoinCode(code);
    setScreen("JOIN");
    handleEnterCode(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Beitritt erfolgreich -> ab in die Lobby
  useEffect(() => {
    if (screen === "JOIN" && room.role === "player" && room.session?.playerId) {
      // Beitritt steht — ab hier trägt die gespeicherte Sitzung, der
      // gescannte Code wird nicht mehr gebraucht.
      sessionStorage.removeItem(PENDING_JOIN_KEY);
      setScreen("LOBBY");
      setJoinInfo(null);
    }
  }, [screen, room.role, room.session]);

  // Host spiegelt seinen Spielstand in den Raum. Die Mitspieler sehen dadurch
  // Aufgabe, Punkte und Verlauf — die Lösung bleibt bewusst beim Host.
  // Bewusst NICHT an room.role: die Rolle kommt vom Socket und faellt auf
  // null, sobald die Raumverbindung wegbricht oder der Raum ablaeuft. Damit
  // sprang der Host mitten im Spiel in die klassische Ansicht — samt
  // "LÖSUNG HALTEN" und "ZUR BEWERTUNG", obwohl alle mit Handys dasassen.
  // Der Modus gehoert zum Spiel, nicht zur Verbindung.
  // Auch die gespeicherte Sitzung zaehlt: ein Mitspieler-Handy kennt seine
  // Rolle schon vor der Antwort des Raums. Seit Buzzer der Standardmodus ist,
  // hielt es sich sonst bis zum "welcome" fuer den Host und schickte hostSync.
  const isBuzzerHost = gameMode === "BUZZER" && room.role !== "player" && room.session?.role !== "player";
  // Dauer eines frischen Songs (Jahr: mindestens 30 s) und die Dauer, an der
  // sich der Countdown-Ring misst. Nach einem Neuladen ist timerGesamt leer —
  // dann gilt die eingestellte Dauer.
  const dauerMs = resolveStartDurationMs("fresh", { timeLimit, taskType });
  const dauerSek = dauerMs ? Math.round(dauerMs / 1000) : null;
  const ringGesamt = timerGesamt || dauerSek;
  // Darf der Host in diesem Moment selbst buzzern? Nur wenn er mitspielt,
  // der Buzzer scharf ist, noch niemand das Wort hat und er für diesen Song
  // nicht schon falsch geraten hat. Sonst behält er die Spielleiter-Rolle:
  // STOPP stoppt dann einfach die Musik.
  const hostCanBuzz =
    isBuzzerHost &&
    !!room.myPlayerId &&
    !!room.room?.buzzArmed &&
    !room.room?.buzz &&
    !(room.room?.lockedOut || []).includes(room.myPlayerId);
  // Einzeln herausgezogen: useRoom() liefert bei jedem Render ein neues
  // Objekt — stünde `room` in den Deps, liefe der Effekt endlos.
  const { sendHostSync, status: roomStatus } = room;
  // Buzzer-Modus: der Host spielt immer mit. Sobald sein Raum verbunden ist,
  // tritt er mit dem Namen aus dem Setup bei — einmal pro Raum (Ref), sonst
  // stuende er bei jedem Re-Render doppelt in der Liste.
  const hostBeigetretenRef = React.useRef(null);
  const raumCode = room.room?.code;
  const hostIstSpieler = (room.room?.players || []).some((p) => p.isHost);
  const hostNameFest = hostPlayerName.trim();
  useEffect(() => {
    if (room.role !== "host" || roomStatus !== "connected") return;
    if (!raumCode || !hostNameFest || hostIstSpieler) return;
    // Nur vor dem Spiel (Lobby): mitten im Spiel stuende der Host sonst als
    // zusaetzlicher Spieler im Raum, aber nicht in der Punkteliste.
    // (Die Raum-Phase taugt dafuer nicht — in der Lobby meldet der Host dort
    // "SETUP", nicht "LOBBY".)
    if (gameState === "PLAYING") return;
    if (hostBeigetretenRef.current === raumCode) return;
    hostBeigetretenRef.current = raumCode;
    room.hostJoinAsPlayer(hostNameFest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [room.role, roomStatus, raumCode, hostNameFest, hostIstSpieler, gameState]);
  useEffect(() => {
    if (!isBuzzerHost) return;
    sendHostSync({
      phase: gameState === "PLAYING" ? roundStage : gameState,
      taskType,
      roundCount,
      // Auch nach Ablauf des Timers (roundStage SOLVED) darf noch gebuzzert
      // werden — die Zeit ist um, geraten werden darf trotzdem.
      // Bei "Jahr" sperrt das Raum-Objekt zusätzlich von sich aus.
      buzzArmed:
        gameState === "PLAYING" &&
        (roundStage === "PLAYING" || roundStage === "SOLVED"),
      // Restzeit in ms zum Zeitpunkt des Sendens; die Handys zählen selbst
      // weiter. So braucht es keine Nachricht pro Sekunde.
      timerMs: remainingFromDeadline(timerDeadlineRef.current, Date.now()) || null,
      // Volle Dauer, damit die Handys den Countdown-Ring zeichnen koennen
      timerTotalMs: ringGesamt ? ringGesamt * 1000 : null,
      // Bleibt im Raum-Objekt privat und geht nur an den, der dran ist.
      // Ohne Titel lieber gar nichts: direkt nach einem Neuladen sind die
      // Songdaten noch leer, und "LÖSUNG: von" hilft niemandem.
      solution: isSongLoading || !songData.title
        ? null
        : {
          title: songData.title,
          artist: songData.artist,
          year: songData.year,
          album: songData.album,
          cover: songData.cover,
        },
      scores: players
        .filter((p) => p.roomId)
        .map((p) => ({ id: p.roomId, score: p.score })),
      history: matchHistory.slice(0, 50),
      // Wer den Punkt dieser Runde hat — nur wenn der Host entschieden hat
      // (vergeben/umgebucht = Name, zurueckgenommen/Keiner = null). Sonst
      // fehlt das Feld und der Raum behaelt die Selbstmeldung. Ohne das
      // zeigten die Handys nach dem Umbuchen weiter den alten Namen.
      punktAn:
        roundStage === "JUDGE" && taskType !== "YEAR"
          ? punktAnIndex !== null
            ? players[punktAnIndex]?.name || null
            : punktEntfernt
              ? null
              : undefined
          : undefined,
    });
  }, [
    punktAnIndex,
    punktEntfernt,
    songData,
    isSongLoading,
    isBuzzerHost,
    gameState,
    roundStage,
    taskType,
    roundCount,
    players,
    matchHistory,
    sendHostSync,
    roomStatus,
    ringGesamt,
  ]);

  // Spielerliste des Hosts mit dem Raum abgleichen. Ohne das fehlen
  // Nachzügler komplett — sie konnten beitreten, tauchten aber beim Host
  // nicht auf und konnten folglich keine Punkte bekommen. Rausgeworfene
  // verschwinden hier ebenfalls.
  const roomPlayerList = room.room?.players;
  useEffect(() => {
    if (!isBuzzerHost || gameState !== "PLAYING") return;
    if (!roomPlayerList || roomPlayerList.length === 0) return;

    setPlayers((prev) => {
      const bekannt = new Map(prev.filter((p) => p.roomId).map((p) => [p.roomId, p]));
      const merged = roomPlayerList.map((rp) => {
        const alt = bekannt.get(rp.id);
        // Punkte bleiben beim Host, Namen kommen aus dem Raum
        return alt ? { ...alt, name: rp.name } : { name: rp.name, score: 0, roomId: rp.id };
      });
      const unveraendert =
        merged.length === prev.length &&
        merged.every((m, i) => prev[i]?.roomId === m.roomId && prev[i]?.name === m.name && prev[i]?.score === m.score);
      return unveraendert ? prev : merged;
    });
  }, [isBuzzerHost, gameState, roomPlayerList]);

  // Host reagiert auf einen Buzz: Musik anhalten. Die Restzeit bleibt
  // erhalten, damit sie nach einer falschen Antwort weiterläuft.
  const handledBuzzRef = React.useRef(null);
  const roomBuzz = room.room?.buzz || null;
  useEffect(() => {
    if (!isBuzzerHost || !roomBuzz) return;
    if (handledBuzzRef.current === roomBuzz.id) return;
    handledBuzzRef.current = roomBuzz.id;
    if (roundStage === "PLAYING") handleStopMusic();
  }, [isBuzzerHost, roomBuzz, roundStage, handleStopMusic]);

  // Jahres-Runde: Sobald die Musik steht, lässt der Host auswerten. Das
  // Rechnen macht der Raum — so sehen alle dieselbe Übersicht.
  useEffect(() => {
    if (!isBuzzerHost || taskType !== "YEAR") return;
    if (roundStage !== "SOLVED" && roundStage !== "JUDGE") return;
    // Nach einem Neuladen steht die Runde nur deshalb auf SOLVED, weil die
    // Musik nicht weiterlaufen kann — nicht, weil die Zeit um war.
    if (jahrAutoStoppRef.current) {
      if (roundStage === "SOLVED") return;
      jahrAutoStoppRef.current = false;
    }
    if (room.room?.yearResult) return;
    if (isSongLoading) return;
    // Kurz warten: die Handys schicken in diesem Moment noch die Zahlen los,
    // die beim Zeitablauf im Feld standen. Ohne die Pause waere die Runde
    // ausgewertet, bevor diese Tipps ankommen.
    //
    // Und nachfassen: send() scheitert still, wenn der Socket gerade zu ist,
    // und der Raum ignoriert die Anfrage, solange ihm das Jahr fehlt. Ein
    // einziger Versuch liess den Host bei "Tipps werden ausgewertet" haengen.
    let iv = null;
    const t = setTimeout(() => {
      room.revealYear();
      iv = setInterval(() => room.revealYear(), 2000);
    }, 1500);
    return () => {
      clearTimeout(t);
      if (iv) clearInterval(iv);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBuzzerHost, taskType, roundStage, room.room?.yearResult, isSongLoading]);

  // Rueckfall: kommt die Auswertung nach 6 s nicht (Raum weg, Song ohne
  // Jahr), vergibt der Host die Punkte von Hand wie im Zuruf-Modus.
  const [jahrAuswertungAus, setJahrAuswertungAus] = useState(null);
  useEffect(() => {
    if (!isBuzzerHost || taskType !== "YEAR" || roundStage !== "JUDGE") return;
    if (room.room?.yearResult) return;
    const t = setTimeout(() => {
      logEvent("raum", "Jahres-Auswertung kam nicht, Vergabe von Hand");
      setJahrAuswertungAus(roundCount);
    }, 6000);
    return () => clearTimeout(t);
  }, [isBuzzerHost, taskType, roundStage, room.room?.yearResult, roundCount]);

  // Steht die Auswertung, ist die Runde entschieden — "nochmal hören" und
  // "auflösen" hätten nichts mehr aufzulösen. Direkt in die Bewertung, sonst
  // klickt sich der Host durch einen Zwischenschirm, der dasselbe zeigt.
  //
  // Und auch ohne Auswertung nicht in "Gestoppt" stehen bleiben: dort sah der
  // Host 1,5 s lang nur seinen eigenen Tipp statt der Aufloesung. Die
  // Bewertung zeigt sofort Song und Jahr, die Uebersicht kommt nach.
  // Ausnahme: nach einem Neuladen (jahrAutoStoppRef) entscheidet der Host.
  useEffect(() => {
    if (!isBuzzerHost || taskType !== "YEAR") return;
    if (roundStage !== "SOLVED") return;
    if (!room.room?.yearResult && jahrAutoStoppRef.current) return;
    setRoundStage("JUDGE");
  }, [isBuzzerHost, taskType, roundStage, room.room?.yearResult]);

  // Ein nicht abgeschickter Tipp gehört der alten Runde. Ohne das stand beim
  // nächsten Song noch die Jahreszahl von vorhin im Feld.
  const raumRunde = room.room?.game?.roundCount;
  useEffect(() => {
    setJahrTipp("");
  }, [raumRunde]);

  // Zeit um, aber die Zahl steht schon im Feld: dann zaehlt sie. Wer tippt
  // und über dem Abschicken von der Zeit erwischt wird, soll nicht leer
  // ausgehen. Unsinn ("12", "0007") bleibt aussen vor.
  const raumPhase = room.room?.game?.phase;
  const raumTaskType = room.room?.game?.taskType;
  const raumAbgegeben = room.room?.yearSubmitted;
  useEffect(() => {
    if (raumTaskType !== "YEAR") return;
    if (!room.myPlayerId) return;
    // Nur wenn die Musik dieser Runde gerade gestoppt wurde. Vorher galt
    // "alles ausser PLAYING" — und damit auch TASK/READY der NAECHSTEN Runde:
    // Beim Rundenwechsel stand der alte, nie abgeschickte Tipp noch im Feld
    // (das Leeren greift erst einen Render spaeter), wurde in die neue Runde
    // geschickt und war dort als "abgegeben" gesperrt (gemeldet 2026-10-05).
    if (raumPhase !== "SOLVED" && raumPhase !== "JUDGE") return;
    if (room.room?.yearResult) return;
    if ((raumAbgegeben || []).includes(room.myPlayerId)) return;
    if (jahrTipp.length !== 4) return;
    const jahr = parseInt(jahrTipp, 10);
    const obergrenze = new Date().getFullYear() + 1;
    if (!Number.isFinite(jahr) || jahr < JAHR_MINDESTWERT || jahr > obergrenze) return;
    // Nur leeren, wenn es rausging — sonst ist der Tipp weg (Socket kurz
    // zu). Beim naechsten Raum-Stand versucht der Effekt es erneut.
    if (room.sendYearGuess(jahr)) setJahrTipp("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [raumTaskType, raumPhase, raumAbgegeben, jahrTipp, room.myPlayerId, room.room?.yearResult]);

  // Punkte für die Jahres-Runde: der Raum hat entschieden, der Host schreibt
  // sie gut. Bei gleichem Abstand bekommen mehrere den Punkt.
  const jahrVerbuchtRef = React.useRef(null);
  const jahrErgebnis = room.room?.yearResult || null;
  // Wer sich selbst als richtig gemeldet hat. Normalerweise steht der Name in
  // lastSolution — die legt der Raum aber nur an, wenn ihm die Loesung
  // vorliegt. Direkt nach einem Neuladen ist sie kurz leer; dann traegt der
  // lokale Merker, sonst boete die Bewertung erneut "PUNKT FÜR:" an und
  // derselbe Punkt liesse sich zweimal vergeben.
  const punktGegeben =
    punktAnIndex !== null
      ? players[punktAnIndex]?.name || `Spieler ${punktAnIndex + 1}`
      : punktEntfernt
        ? null
        : room.room?.lastSolution?.by || selbstGemeldet;
  // Runde ist gelaufen: es gibt nur noch einen Weg vorwaerts.
  const rundeEntschieden = taskType === "YEAR" || !!punktGegeben;
  // Spielt der Host die Jahres-Runde mit, steht sein Tippfeld ganz oben.
  const jahrEingabeOben =
    isBuzzerHost && !!room.myPlayerId && taskType === "YEAR" && roundStage !== "JUDGE";
  useEffect(() => {
    if (!isBuzzerHost || !jahrErgebnis) return;
    const marke = `${roundCount}:${jahrErgebnis.correctYear}`;
    if (jahrVerbuchtRef.current === marke) return;
    jahrVerbuchtRef.current = marke;
    // Der Ref ueberlebt kein Neuladen. Laedt der Host in der Bewertung neu,
    // liegt die Auswertung im Raum weiterhin vor — und die Punkte waeren ein
    // zweites Mal vergeben worden. Der Verlauf ist das Gedaechtnis, das
    // bleibt: steht die Runde dort schon, ist sie verbucht.
    if (matchHistory.some((e) => e.roundNumber === roundCount)) return;

    const gewinner = jahrErgebnis.winners || [];
    if (gewinner.length === 0) {
      setMatchHistory((prev) => [buildHistoryEntry(null, null), ...prev]);
      return;
    }
    setPlayers((prev) =>
      prev.map((p) => (p.roomId && gewinner.includes(p.roomId) ? { ...p, score: p.score + 1 } : p))
    );
    setMatchHistory((prev) => {
      const neue = gewinner.map((id) => {
        const treffer = jahrErgebnis.entries.find((e) => e.playerId === id);
        const idx = players.findIndex((p) => p.roomId === id);
        // Name kommt aus der Auswertung, nicht aus dem Index: findet sich der
        // Platz gerade nicht (Nachzuegler, gerade neu gemischte Liste), stand
        // im Verlauf sonst "kein Punkt vergeben", obwohl jemand gewonnen hat.
        const name = treffer?.name || (idx === -1 ? "Mitspieler" : players[idx].name);
        return buildHistoryEntry(idx === -1 ? null : idx, name);
      });
      return [...neue, ...prev];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBuzzerHost, jahrErgebnis]);

  // Host wertet die Selbsteinschätzung aus. Punkte schreibt weiterhin nur er —
  // sonst würde der nächste Sync das Ergebnis überschreiben.
  const handledEventRef = React.useRef(null);
  const roomEvent = room.room?.lastEvent || null;
  useEffect(() => {
    if (!isBuzzerHost || !roomEvent) return;
    if (handledEventRef.current === roomEvent.id) return;
    handledEventRef.current = roomEvent.id;

    if (roomEvent.type === "selfReport" && roomEvent.correct) {
      const idx = players.findIndex((p) => p.roomId === roomEvent.playerId);
      if (idx !== -1) {
        handleScore(idx, false, true);
        // Damit der Name in der Bewertung schon angehakt ist — der Host soll
        // sehen, wer den Punkt hat, und ihn notfalls umbuchen koennen.
      }
      setSelbstGemeldet(roomEvent.name || (idx !== -1 ? players[idx].name : "Mitspieler"));
      // Erst die Auflösung ansehen, dann weiter — genau wie auf den Handys.
      setShowSolution(false);
      setRoundStage("JUDGE");
    } else {
      // Falsch geraten ODER der Spieler am Wort ist rausgeflogen
      // ("buzzAbandoned"): in beiden Fällen darf der Rest weiterraten.
      // Falsch geraten: der Rest darf weiter mitraten, Musik läuft an der
      // gestoppten Stelle weiter.
      const nochWer = players.some(
        (p) =>
          p.roomId &&
          p.roomId !== roomEvent.playerId &&
          !(room.room?.lockedOut || []).includes(p.roomId)
      );
      if (nochWer) {
        handleStartMusic("resume");
      } else {
        // Niemand darf mehr raten. Die Runde ist damit entschieden, also
        // gleich auflösen, statt den Host vor einem toten Bildschirm sitzen
        // zu lassen, auf dem nichts mehr passieren kann.
        logEvent("runde", "alle raus — direkt zur Aufloesung");
        if (isBuzzerHost && !isSongLoading) room.revealToAll();
        setShowSolution(false);
        setRoundStage("JUDGE");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBuzzerHost, roomEvent]);

  // Mitspieler-Countdown. Der Host schickt nur die Restzeit, wenn sich
  // ohnehin etwas ändert — heruntergezählt wird hier lokal, sonst bräuchte
  // es eine Nachricht pro Sekunde.
  const [playerTimer, setPlayerTimer] = useState(null);
  const roomTimerMs = room.room?.game?.timerMs ?? null;
  const roomPhase = room.room?.game?.phase;
  useEffect(() => {
    if (roomTimerMs === null || roomTimerMs === undefined) {
      setPlayerTimer(null);
      return;
    }
    // Läuft die Musik nicht, steht die Uhr — genau wie beim Host.
    if (roomPhase !== "PLAYING") {
      setPlayerTimer(Math.max(0, Math.ceil(roomTimerMs / 1000)));
      return;
    }
    const bis = Date.now() + roomTimerMs;
    const tick = () => setPlayerTimer(Math.max(0, Math.ceil((bis - Date.now()) / 1000)));
    tick();
    const id = setInterval(tick, 250);
    return () => clearInterval(id);
  }, [roomTimerMs, roomPhase]);

  // Welche Rolle dieses Geraet zuletzt hatte. Beim Ablaufen des Raums wirft
  // useRoom die Sitzung weg — danach ist nicht mehr erkennbar, ob hier ein
  // Host oder ein Mitspieler sitzt.
  const sessionRolleRef = React.useRef(null);
  useEffect(() => {
    if (room.session?.role) sessionRolleRef.current = room.session.role;
  }, [room.session]);

  // Rausgeworfen oder Raum abgelaufen -> zurück zur Beitritts-Ansicht,
  // die den Grund nennt. Ohne das blieb man in einer leeren Lobby hängen,
  // die endlos "Verbinde…" anzeigte.
  useEffect(() => {
    if ((room.kicked || room.status === "gone") && screen === "LOBBY") {
      // Den Host schickt es dabei NICHT in die Beitritts-Maske: er hostet ja,
      // ein "Code vom Host eingeben" ist fuer ihn Unsinn. Er gehoert zurueck
      // in den Aufbau, wo er eine neue Lobby oeffnen kann.
      if (gameMode === "BUZZER" && sessionRolleRef.current === "host") {
        setScreen(null);
        setJoinInfo(null);
        return;
      }
      setScreen("JOIN");
      setJoinInfo(null);
      setJoinCode("");
    }
  }, [room.kicked, room.status, screen, gameMode]);

  // Nach einem Reload zurück in den Raum — aber wirklich nur dann.
  //
  // Die alte Sperre wurde erst gesetzt, WENN der Effekt einmal zugeschlagen
  // hatte. Beim Host, der ein Spiel startet, passierte das nie: waehrend
  // "PLAYING" trifft keine Bedingung zu. Klickte er dann auf BEENDEN, war
  // gameState ploetzlich "FINISHED" — also nicht mehr "PLAYING" — und der
  // Effekt warf ihn in die Lobby, mitsamt QR-Code, statt aufs Podest.
  //
  // Deshalb: Sobald in dieser Sitzung ein Spiel lief, ist der Wiedereinstieg
  // nicht mehr zustaendig. Und ein beendetes Spiel gehoert ohnehin aufs
  // Ergebnis, nicht in die Lobby.
  const spielLiefRef = React.useRef(false);
  useEffect(() => {
    if (gameState === "PLAYING") spielLiefRef.current = true;
  }, [gameState]);

  const restoreDoneRef = React.useRef(false);
  useEffect(() => {
    if (restoreDoneRef.current || spielLiefRef.current) return;
    if (screen !== null || !room.session || !room.role) return;
    const hostWaiting =
      room.role === "host" && gameState !== "PLAYING" && gameState !== "FINISHED";
    const playerWaiting = room.role === "player";
    if (hostWaiting || playerWaiting) {
      restoreDoneRef.current = true;
      setScreen("LOBBY");
    }
  }, [screen, room.session, room.role, gameState]);




  // --- SCREEN RENDERING ---

  // Mitspieler brauchen KEIN Spotify — der Beitritt läuft komplett am
  // Login vorbei. Nur der Host ist mit seinem Account verbunden.
  if (screen === "JOIN") {
    return (
      <JoinScreen
        room={room}
        joinInfo={joinInfo}
        joinCode={joinCode}
        setJoinCode={setJoinCode}
        joinName={joinName}
        setJoinName={setJoinName}
        joinBusy={joinBusy}
        onEnterCode={handleEnterCode}
        onAbbrechen={() => {
          sessionStorage.removeItem(PENDING_JOIN_KEY);
          room.leaveRoom();
          setJoinInfo(null);
          setJoinCode("");
          setScreen(null);
        }}
      />
    );
  }
  if (screen === "LOBBY") {
    // Sobald der Host startet, wechseln die Mitspieler in die Zuschauer-Ansicht.
    const roomPhase = room.room?.game?.phase || "LOBBY";
    if (room.role === "player" && roomPhase !== "LOBBY" && roomPhase !== "SETUP") {
      return (
        <PlayerGameScreen
          room={room}
          playerTimer={playerTimer}
          jahrErgebnis={jahrErgebnis}
          jahrTipp={jahrTipp}
          setJahrTipp={setJahrTipp}
          showHistoryModal={showHistoryModal}
          setShowHistoryModal={setShowHistoryModal}
          showLeaveConfirm={showLeaveConfirm}
          setShowLeaveConfirm={setShowLeaveConfirm}
          onVerlassen={() => {
            sessionStorage.removeItem(PENDING_JOIN_KEY);
            setShowLeaveConfirm(false);
            room.leaveRoom();
            setJoinInfo(null);
            setJoinCode("");
            setScreen(null);
          }}
        />
      );
    }
    return (
      <LobbyScreen
        room={room}
        hostPlayerName={hostPlayerName}
        setHostPlayerName={setHostPlayerName}
        onStart={(raumSpieler) => {
          // Die beigetretenen Namen werden zur Spielerliste. roomId
          // verbindet den lokalen Spieler mit seinem Platz im Raum —
          // darüber laufen später die Punktestände zurück.
          setPlayers(raumSpieler.map((p) => ({ name: p.name, score: 0, roomId: p.id })));
          // Punkte werden hier auf 0 gesetzt — der Verlauf blieb dabei
          // stehen. Startete der Host im selben Raum ein zweites Spiel,
          // sahen die Mitspieler auf dem Ergebnis-Bildschirm noch die
          // Runden des vorigen Abends.
          setMatchHistory([]);
          setRoundCount(1);
          setVotedPlayers([]);
          setScreen(null);
          startGame();
        }}
        onVerlassen={() => {
          sessionStorage.removeItem(PENDING_JOIN_KEY);
          room.leaveRoom();
          setJoinInfo(null);
          setScreen(null);
        }}
      />
    );
  }

  if (gameState === "LOGIN") {
    return (
      <LoginScreen
        authError={authError}
        onMitspielen={() => {
          setJoinCode("");
          setScreen("JOIN");
        }}
      />
    );
  }
  const renderDeviceModal = () =>
    showDeviceModal && (
      <GeraeteDialog
        devices={devices}
        devicesLoading={devicesLoading}
        deviceError={deviceError}
        sdkGeraetId={sdkGeraetId}
        sdkFehler={sdkFehler}
        sdkBrauchtNeuanmeldung={sdkBrauchtNeuanmeldung}
        onActivate={activateDevice}
        onReload={loadDevices}
        onReconnect={handleReconnect}
        onOpenDiag={() => {
          setShowDeviceModal(false);
          setShowDiagModal(true);
        }}
        onClose={() => setShowDeviceModal(false)}
      />
    );
  const renderDiagModal = () =>
    showDiagModal && (
      <ProtokollDialog
        kontext={{
          Status: spotifyStatus,
          "aktives Geraet": activeDeviceId || "keins",
          Spielphase: `${gameState}/${roundStage}`,
          Modus: gameMode,
        }}
        onClose={() => setShowDiagModal(false)}
      />
    );


  const renderRoomModal = () => {
    const code = room.session?.code || room.room?.code || "";
    if (!showRoomModal || !code) return null;
    return <RaumDialog code={code} onClose={() => setShowRoomModal(false)} />;
  };


  // Das History-Modal wird von MEHREREN Screens gebraucht (Spiel + Ergebnis).
  // Vorher stand es nur im Haupt-Return -> auf dem Ergebnis-Screen passierte beim Klick nichts.
  const renderHistoryModal = () => {
    if (!showHistoryModal) return null;
    return (
      <HistoryModal
        eintraege={matchHistory}
        leerText="Noch keine Punkte in dieser Runde vergeben."
        onClose={() => setShowHistoryModal(false)}
        namen={players.map((p, i) => p.name || `Spieler ${i + 1}`)}
        aktionen={(entry) => (
          <Umbuchen
            /* Ueber die Person aufgeloest, nicht ueber den gemerkten Platz —
               sonst steht nach einem Rauswurf der falsche Name in der Auswahl. */
            wert={spielerIndexVon(entry) === null ? -1 : spielerIndexVon(entry)}
            spieler={players.map((p, i) => p.name || `Spieler ${i + 1}`)}
            onUmbuchen={(wert) => handleReassignHistoryEntry(entry.id, wert < 0 ? null : wert)}
            onLoeschen={() => handleDeleteHistoryEntry(entry.id)}
          />
        )}
      />
    );
  };

  // Im SETUP-Return-Block:
  // --- SETUP SCREEN ---
  if (gameState === "SETUP") {
    return (
      <SetupScreen
        spotifyStatus={spotifyStatus}
        onOpenDevices={openDevicePicker}
        gameMode={gameMode}
        setGameMode={setGameMode}
        players={players}
        setPlayers={setPlayers}
        onAddPlayer={addPlayer}
        hostName={hostPlayerName}
        setHostName={setHostPlayerName}
        activeTasks={activeTasks}
        setActiveTasks={setActiveTasks}
        timeLimit={timeLimit}
        setTimeLimit={setTimeLimit}
        onStart={startGame}
        // Laeuft noch ein eigener Raum, fuehrt der Weg dorthin zurueck.
        // Ein neuer Raum bekommt einen neuen Code — die Mitspieler
        // sassen danach in einem Raum ohne Host und warteten ewig.
        laufenderRaum={room.session?.role === "host" ? room.session?.code : null}
        onZurueckInLobby={() => setScreen("LOBBY")}
        onLobbyOeffnen={async () => {
          try {
            await room.hostOpenLobby({ timeLimit, activeTasks });
            setScreen("LOBBY");
          } catch (e) {
            room.setError("Lobby konnte nicht geöffnet werden.");
          }
        }}
        onMitspielen={() => {
          setJoinCode("");
          setJoinInfo(null);
          setScreen("JOIN");
        }}
        onLogout={handleLogout}
      >
        {renderDeviceModal()}
        {renderDiagModal()}
      </SetupScreen>
    );
  }

  if (gameState === "FINISHED") {
    return (
      <FinishedScreen
        players={players}
        matchHistory={matchHistory}
        onLogout={handleLogout}
        onShowHistory={() => setShowHistoryModal(true)}
        onNeueRunde={() => {
          setPlayers(players.map(p => ({ ...p, score: 0 })));
          setMatchHistory([]);
          setRoundCount(1);
          resetPlaylistTracking();
          setGameState("SETUP");
          localStorage.removeItem("musicQuizState");
        }}
      >
        {renderHistoryModal()}
      </FinishedScreen>
    );
  }

  // --- HOST-SPIEL: Aktionen der Steuerknoepfe ---

  const beendeSpiel = () => {
    // Erst die Musik: sonst laeuft der Song ueber dem Podium
    // weiter, waehrend alle auf den Endstand schauen.
    if (timerRef.current) clearInterval(timerRef.current);
    timerDeadlineRef.current = null;
    timerRemainingMsRef.current = 0;
    setTimer(null);
    controlSpotify("pause");
    localStorage.removeItem("musicQuizState");
    // Ausdruecklich: nichts darf das Ergebnis ueberlagern
    setScreen(null);
    setGameState("FINISHED");
    setShowExitConfirm(false);
  };

  const starteNaechstenSong = async () => {
    if (bereitLaeuftRef.current) return;
    bereitLaeuftRef.current = true;
    setBereitLaeuft(true);
    const previousId = currentSongIdRef.current;
    setIsSongLoading(true);

    // WICHTIG: erst stummschalten, dann weiterschalten.
    // Vorher wurde die Wiedergabe mit play:true auf das Gerät übertragen —
    // das setzte den ALTEN Song fort, und erst danach kam "next".
    // Genau das war die halbe Sekunde vom alten Titel.
    //
    // Beides läuft bewusst über controlSpotify: das nimmt bei
    // eigener Wiedergabe den Player direkt und holt bei einem
    // 404 das Gerät zurück. Die früheren Direktaufrufe hier
    // adressierten stur die gemerkte device_id — war die nach
    // einer Neuverbindung veraltet, verpuffte "next" stumm und
    // es lief endlos derselbe Song.
    await controlSpotify("pause");
    await controlSpotify("next");

    // Erst abspielen, wenn Spotify wirklich den NEUEN Titel
    // meldet. Vorher lief play() nach festen 250 ms los — hatte
    // "next" da noch nicht gegriffen, hörte der Tisch eine
    // Sekunde des alten Songs, bevor umgeschaltet wurde.
    const warteAufNeuenSong = async (versuch = 1) => {
      const geladen = await fetchCurrentSong(token, true, previousId);
      // Ref statt State: currentSongId war hier aus dem Render
      // eingefroren und wurde in der Schleife nie aktuell.
      const neuerDa = geladen && currentSongIdRef.current !== previousId;

      // Nicht endlos warten: nach ~2,5 s zaehlt, dass die Runde
      // laeuft. Lieber ein Titel zu frueh als ein toter Knopf.
      if (neuerDa || versuch >= 8) {
        if (!neuerDa) {
          // Steht das im Protokoll, hat "next" nicht gegriffen —
          // das ist der Fall "es läuft immer derselbe Song".
          logEvent("wiedergabe", "neuer Song kam nicht", { versuche: versuch });
        }
        setIsSongLoading(false);
        handleStartMusic("fresh");
        bereitFertig();
        return;
      }
      setTimeout(() => warteAufNeuenSong(versuch + 1), 300);
    };
    setTimeout(() => warteAufNeuenSong(1), 250);
  };

  const stoppOderBuzz = () => {
    // Spielt der Host mit und darf er gerade buzzern, IST
    // sein STOPP-Knopf der Buzzer.
    // Darf er NICHT (schon falsch geraten, oder jemand
    // anderes ist dran), muss STOPP schlicht die Musik
    // anhalten — vorher lief der Buzz ins Leere, der Server
    // lehnte ihn ab und der Host konnte die Runde bis zum
    // Ablauf des Timers nicht mehr beenden.
    if (hostCanBuzz) {
      room.buzz();
    } else {
      handleStopMusic();
    }
  };

  // "Keiner" in der Bewertung: vergebene Punkte dieser Runde zuruecknehmen,
  // ueber denselben Weg wie das Abwaehlen einer Kachel — und die Wahl
  // sichtbar festhalten. Vorher passierte beim Antippen ohne vergebenen
  // Punkt gar nichts, "Keiner" liess sich also nicht auswaehlen.
  // Gilt nur fuer die Runde, in der getippt wurde (keinerRunde, oben).
  const keinerGewaehlt =
    keinerRunde === roundCount && !punktGegeben && votedPlayers.length === 0;
  const nimmPunkteZurueck = () => {
    if (keinerGewaehlt) {
      setKeinerRunde(null);
      return;
    }
    if (taskType === "YEAR" && !jahrErgebnis) {
      votedPlayers.forEach((i) => vergebePunkt(i));
    } else if (punktAnIndex !== null) {
      vergebePunkt(punktAnIndex);
    } else if (punktGegeben) {
      // Punkt stammt nur aus einer Selbstmeldung, ohne Verlaufseintrag (der
      // Melder stand beim Host nicht in der Liste). Dann gab es nichts
      // abzuwaehlen — "Keiner" blieb wirkungslos und "Naechste Runde" liess
      // die Runde im Verlauf aus. Jetzt: Meldung verwerfen, die Runde gilt
      // als "kein Punkt" (skipRound legt den Eintrag an).
      setSelbstGemeldet(null);
      setPunktEntfernt(true);
    }
    setKeinerRunde(roundCount);
  };
  const vergebePunktKachel = (i) => {
    setKeinerRunde(null);
    vergebePunkt(i);
  };

  const naechsteRunde = () => {
    if (taskType === "YEAR" && !jahrErgebnis) {
      // Klassische Jahres-Runde: mehrere Punkte möglich
      finishRound(true);
    } else if (rundeEntschieden) {
      // Punkte und Verlauf stehen schon
      prepareNextTask();
    } else {
      // Keiner wusste es — Runde ohne Punkt vermerken
      skipRound();
    }
  };

  const weckeGeraet = async () => {
    // Der Knopf muss IMMER zu etwas führen. Vorher konnte die stille
    // Erholung scheitern (mehrere Geräte, keins passend) und es
    // passierte sichtbar gar nichts.
    setGeraeteSucheLaeuft(true);
    logEvent("geraet", "manuell aufgeweckt");
    try {
      const id = await ensureActiveDevice();
      if (id) {
        setSpotifyStatus("CONNECTED");
      } else {
        openDevicePicker();
      }
    } finally {
      setGeraeteSucheLaeuft(false);
    }
  };

  // "Hier abspielen": die Quiz-Seite selbst wird das Wiedergabegeraet.
  // Das ist auf dem Handy der stabile Weg — die Spotify-App friert iOS
  // 5–10 s nach dem Pausieren ein (siehe CLAUDE.md, Web Playback SDK).
  // Ist der eigene Player gerade abgerissen, wird er erst neu verbunden.
  const hierAbspielen = async () => {
    setGeraeteSucheLaeuft(true);
    logEvent("geraet", "hier abspielen gewaehlt");
    try {
      // Laeuft die Runde, gleich weiterspielen — sonst liefe der Countdown
      // ohne Ton weiter
      const id = await holeHierher("manuell", roundStage === "PLAYING");
      if (id) setSpotifyStatus("CONNECTED");
      else openDevicePicker();
    } finally {
      setGeraeteSucheLaeuft(false);
    }
  };

  const oeffneSpotifyApp = () => {
    logEvent("geraet", "Spotify-App geoeffnet");
    setTimeout(() => ensureActiveDevice(), 2500);
  };

  // Buzzer-Bereich des mitspielenden Hosts. In der Jahres-Runde steht er
  // ueber den Steuerknoepfen (sonst rutscht "Abschicken" unter den Rand),
  // in der Bewertung gar nicht mehr: dort ist die Runde vorbei.
  const hostBuzzer =
    jahrEingabeOben || (isBuzzerHost && room.myPlayerId && roundStage !== "JUDGE") ? (
      <BuzzerArea
        room={room}
        jahrTipp={jahrTipp}
        setJahrTipp={setJahrTipp}
        hideBuzzButton
        farbe={farbNummern((room.room?.players || []).map((p) => p.name))}
      />
    ) : null;

  // Der mitspielende Host hat gebuzzert: er bekommt denselben Bildschirm
  // wie die Handys (Loesung aufdecken, Richtig/Falsch).
  const hostIstDran =
    isBuzzerHost && !!room.myPlayerId && room.room?.buzz?.playerId === room.myPlayerId;
  const hostName =
    (room.room?.players || []).find((p) => p.id === room.myPlayerId)?.name || room.room?.buzz?.name || "";

  return (
    <HostSpiel
      gameMode={gameMode}
      raumCode={room.session?.code}
      roomStatus={roomStatus}
      roundCount={roundCount}
      roundStage={roundStage}
      taskType={taskType}
      timer={timer}
      timerGesamt={ringGesamt}
      dauerSek={dauerSek}
      players={players}
      verlaufAnzahl={matchHistory.length}
      isBuzzerHost={isBuzzerHost}
      hostBuzzer={hostBuzzer}
      jahrEingabeOben={jahrEingabeOben}
      bereitLaeuft={bereitLaeuft}
      songData={songData}
      isSongLoading={isSongLoading}
      // Die Punkte hat der Raum ausgerechnet und der Host bereits
      // verbucht — dann nur noch anschauen.
      jahrErgebnis={isBuzzerHost && taskType === "YEAR" ? jahrErgebnis : null}
      meineId={room.myPlayerId}
      raumSpieler={room.room?.players || []}
      punktGegeben={punktGegeben}
      hatPunkt={(i) => punktAnIndex === i || votedPlayers.includes(i)}
      menueOffen={showExitConfirm}
      setMenueOffen={setShowExitConfirm}
      onVergebePunkt={vergebePunktKachel}
      onKeiner={nimmPunkteZurueck}
      keinerGewaehlt={keinerGewaehlt}
      jahrAuswertungAus={jahrAuswertungAus === roundCount}
      onNaechsteRunde={naechsteRunde}
      onWeiterhoeren={() => handleScore(null, false)}
      onBereit={starteNaechstenSong}
      // Pfeilfunktion noetig: onClick={handleStartMusic} wuerde das
      // Click-Event als mode durchreichen.
      onStart={() => handleStartMusic("fresh")}
      onStopp={stoppOderBuzz}
      onSkip={skipRound}
      onNochmal={() => handleStartMusic("resume")}
      onAufloesen={isBuzzerHost ? skipRound : () => setRoundStage("JUDGE")}
      setShowSolution={setShowSolution}
      onShowHistory={() => setShowHistoryModal(true)}
      onShowSettings={() => setShowSettings(true)}
      onShowScores={() => setShowMobileScores(true)}
      onShowRoom={() => setShowRoomModal(true)}
      onBeenden={beendeSpiel}
      leisten={
        <>
          {/* Zwei offene Host-Fenster schrieben abwechselnd ihren Spielstand in
              denselben Raum. Jetzt steuert nur das zuletzt verbundene — und
              dieses hier sagt, warum seine Klicks nichts mehr bewirken.
              Neu laden macht es wieder zum steuernden Fenster. */}
          {room.abgeloest && (
            <Leiste farbe="rot" icon="fenster" titel="Anderes Fenster steuert" text="Dort weiterspielen oder hier.">
              <Button variant="neben" onClick={() => window.location.reload()}>
                Übernehmen
              </Button>
            </Leiste>
          )}
          {zeigeGeraeteBanner && (
            <GeraeteBanner
              geraetVerschwunden={geraetVerschwunden}
              spotifyStatus={spotifyStatus}
              sucht={geraeteSucheLaeuft}
              onSpotifyOeffnen={oeffneSpotifyApp}
              onWecken={weckeGeraet}
              onHierAbspielen={sdkFehler ? null : hierAbspielen}
            />
          )}
          {needsReauth && <ReauthBanner onReconnect={handleReconnect} />}
        </>
      }
    >
      {showRepeatWarning && (
        <WiederholungDialog
          onWeiter={() => {
            setShowRepeatWarning(false);
            // "Verstanden" — fuer diese Playlist nicht nochmal warnen
            setPlaylistWarningMuted(true);
          }}
          onBeenden={() => {
            setShowRepeatWarning(false);
            setShowExitConfirm(true);
          }}
        />
      )}
      {showSolution && (
        <LoesungHaltenOverlay
          isSongLoading={isSongLoading}
          songData={songData}
          onClose={() => setShowSolution(false)}
        />
      )}

      {showSettings && (
        <EinstellungenDialog
          spotifyStatus={spotifyStatus}
          onOpenDevices={openDevicePicker}
          timeLimit={timeLimit}
          setTimeLimit={setTimeLimit}
          activeTasks={activeTasks}
          setActiveTasks={setActiveTasks}
          players={players}
          setPlayers={setPlayers}
          gameMode={gameMode}
          onAddPlayer={addPlayer}
          onLogout={handleLogout}
          onClose={() => setShowSettings(false)}
        />
      )}
      {showMobileScores && (
        <PunkteDialog players={players} setPlayers={setPlayers} onClose={() => setShowMobileScores(false)} />
      )}

      {renderHistoryModal()}
      {renderDeviceModal()}
      {renderDiagModal()}
      {renderRoomModal()}

      {hostIstDran && (
        <DuBistDran
          name={hostName}
          farbe={farbNummern(players.map((p, i) => p.name || `Spieler ${i + 1}`))(hostName)}
          taskType={taskType}
          loesung={room.revealedSolution}
          onAufdecken={room.requestSolution}
          onRichtig={() => room.reportAnswer(true)}
          onFalsch={() => room.reportAnswer(false)}
        />
      )}
    </HostSpiel>
  );
}

export default App;
